/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface HealthcheckEntity {
  status: string;
}

export interface UpdateAddressDto {
  countryId?: string;
  streetAddress?: string;
  city?: string;
  state?: string;
  zipCode?: string;
}

export interface AddressDto {
  id: string;
  countryId: string;
  streetAddress: string | null;
  city: string | null;
  state: string | null;
  zipCode: string | null;
  createdAt: string;
  updatedAt: string | null;
}

export interface AddressComponent {
  longText: string;
  shortText: string;
  types: string[];
  languageCode: string;
}

export interface PlusCode {
  globalCode: string;
  compoundCode: string;
}

export interface Location {
  latitude: number;
  longitude: number;
}

export interface DisplayName {
  text: string;
  languageCode: string;
}

export interface SubDestination {
  name: string;
  id: string;
}

export interface GooglePlace {
  name: string;
  types: string[];
  formattedAddress: string;
  addressComponents: AddressComponent[];
  plusCode: PlusCode;
  location: Location;
  utcOffsetMinutes: number;
  displayName: DisplayName;
  shortFormattedAddress: string;
  subDestinations: SubDestination[];
}

export interface CreateArtistAddressDto {
  artistId: string;
  formattedAddress: string;
  googlePlace?: GooglePlace;
}

export interface ArtistAddressDto {
  id: string;
  artistId: string;
  formattedAddress: string;
  googlePlace: GooglePlace | null;
  createdAt: string;
  updatedAt: string | null;
}

export interface ArtistAddressesQueryDto {
  artistId: string;
  /** @maxLength 100 */
  address: string;
}

export interface ArtistAddressesDto {
  artistAddresses: ArtistAddressDto[];
}

export interface CreateUserDto {
  email: string;
  password: string;
  firstName?: string;
  lastName?: string;
}

export interface UserIdDto {
  id: string;
}

export interface UserStatusDto {
  id: string;
  onboardingCompleted: boolean;
  onboardingSkipped: boolean;
}

export interface UserDto {
  id: string;
  firstName: string | null;
  lastName: string | null;
  aboutMe: string | null;
  email: string;
  grantedPremiumAccess: boolean;
  isVenue: boolean;
  admin: boolean;
  createdAt: string;
  updatedAt: string | null;
  personalWorkspaceId: string;
  avatarUrl: string | null;
  status: UserStatusDto;
  subscriptionStatus?: string | null;
}

export interface UpdateUserDto {
  firstName?: string | null;
  lastName?: string | null;
  aboutMe?: string | null;
}

export interface UpdatePasswordDto {
  newPassword: string;
  currentPassword: string;
}

export interface PublicResetPasswordDto {
  password: string;
}

export interface UserAvatarDto {
  key: string | null;
}

export interface UpdateUserStatusDto {
  onboardingCompleted?: boolean;
  onboardingSkipped?: boolean;
}

export interface UpdateUserStatusResponseDto {
  id: string;
}

export interface AuthLoginDto {
  email: string;
  password: string;
}

export interface AuthTokensResponseDto {
  accessToken: string;
  refreshToken: string;
}

export interface AuthRegisterDto {
  email: string;
  password: string;
}

export interface RegisteredUserResponseDto {
  email: string;
}

export interface RefreshTokenDto {
  refreshToken: string;
}

export interface ResetPasswordDto {
  email: string;
}

export interface WorkspaceDto {
  id: string;
  name: string;
  ownerId: string;
  createdAt: string;
  updatedAt: string | null;
}

export interface WorkspacesDto {
  workspaces: WorkspaceDto[];
}

export interface UpdateWorkspaceDto {
  name: string;
}

export interface ArtistDto {
  id: string;
  name: string;
  logoKey: string | null;
  posterKey: string | null;
  hexColorCode: string | null;
  workspaceId: string;
  createdAt: string;
  updatedAt: string | null;
  archived: boolean;
}

export interface ArtistsDto {
  artists: ArtistDto[];
}

export interface WorkspaceMemberUserDto {
  id: string;
  email: string;
  firstName: string | null;
  lastName: string | null;
}

export interface WorkspaceMemberDto {
  id: string;
  userId: string;
  workspaceId: string;
  roleId: string;
  user: WorkspaceMemberUserDto;
  createdAt: string;
  updatedAt: string | null;
}

export interface WorkspaceMembersDto {
  workspaceMembers: WorkspaceMemberDto[];
}

export interface CreateArtistDto {
  name: string;
  logoKey?: string;
  posterKey?: string;
  hexColorCode?: string;
  workspace_id: string;
}

export interface UpdateArtistDto {
  name?: string;
  logoKey?: string;
  posterKey?: string;
  hexColorCode?: string;
  workspace_id?: string;
}

export interface UploadArtistFileDto {
  fileType: "logo" | "poster";
  workspaceId: string;
}

export interface UploadedFileKeyDto {
  key: string | null;
}

export interface DeleteArtistFileDto {
  fileType: "logo" | "poster";
  workspaceId: string;
}

export interface CreateEventTemplateCategoryDto {
  name: string;
}

export interface EventTemplateCategoryDto {
  id: string;
  artistId: string;
  name: string;
  /** @format date-time */
  createdAt: string;
  updatedAt: string | null;
}

export interface EventTemplateCategoriesDto {
  templateCategories: EventTemplateCategoryDto[];
}

export interface UpdateEventTemplateCategoryDto {
  name?: string;
}

export interface CreateEventTemplateDto {
  categoryId?: string;
  /**
   * The ID country from countries table in schema.ts, not the code
   * @example "123e4567-e89b-12d3-a456-426614174000"
   */
  name?: string;
  description?: string;
  events: string[];
}

export interface EventDetails {
  name: string;
  description: string;
}

export interface LatLngDto {
  latitude: number | null;
  longitude: number | null;
}

export interface GoogleRouteInfo {
  distanceMeters: number | null;
  duration: string | null;
  encodedPolyline: string | null;
  routeToken: string | null;
  googleMapsLink: string | null;
}

export interface AirportInfoDto {
  codeIcao: string;
  timezone: string;
  name: string;
  city: string;
}

export interface FlightInfoDto {
  identIcao: string;
  identIata: string;
  scheduledIn: string;
  scheduledOut: string;
  scheduledInLocal?: string;
  scheduledInLocalDisplay?: string;
  scheduledInLocalTime?: string;
  scheduledOutLocal?: string;
  scheduledOutLocalDisplay?: string;
  scheduledOutLocalTime?: string;
  origin: AirportInfoDto;
  destination: AirportInfoDto;
}

export interface PrivateFlightInfo {
  tailNumber: string | null;
  departureFBO: string | null;
  departureTime: string | null;
  arrivalFBO: string | null;
  arrivalTime: string | null;
  jetType: string | null;
  numberOfSeats: string | null;
  notes: string | null;
}

export interface ReservationNumber {
  /** @deprecated */
  userEmail?: object | null;
  userName?: object | null;
  number: string;
}

export interface EventTravelAdditionalInformation {
  departureOrigin: string | null;
  arrivalOrigin: string | null;
  departureTime: string | null;
  departureTimeLocal: string | null;
  departureTimeLocalDisplay: string | null;
  departureTimeLocalTime: string | null;
  destination: string | null;
  destinationTimezone: string | null;
  arrivalTime: string | null;
  arrivalTimeLocal: string | null;
  arrivalTimeLocalDisplay: string | null;
  arrivalTimeLocalTime: string | null;
  originCoordinates: LatLngDto | null;
  destinationCoordinates: LatLngDto | null;
  routeInfo: GoogleRouteInfo | null;
  travelType: "ground" | "air" | "private jet" | "rail" | "sea" | null;
  departureOriginAirportCode: string | null;
  arrivalOriginAirportCode: string | null;
  flightNumber: string | null;
  trainNumber: string | null;
  sealNumber: string | null;
  ticketsStatus: "bought" | "missing" | null;
  flightStatus: "tentative" | "on hold" | "confirmed" | "ticketed" | "cancelled" | "refunded" | null;
  groundTravelStatus: "confirmed" | "unconfirmed" | null;
  flightInfo: FlightInfoDto | null;
  privateFlightInfo: PrivateFlightInfo | null;
  reservationNumbers: ReservationNumber[] | null;
}

export interface EventLoadInAdditionalInformation {
  requiredEquipment: string | null;
}

export interface EventPromoAdditionalInformation {
  mediaOutlet: string | null;
  interviewerName: string | null;
}

export interface EventHotelAdditionalInformation {
  phoneNumber: string | null;
  email: string | null;
  website: string | null;
  keyContacts: string | null;
  facilities: string[] | null;
  hotelName: string | null;
}

export interface EventShowAdditionalInformation {
  inventory: number | null;
  originCoordinates: LatLngDto | null;
}

export interface EventAdditionalInformation {
  travel: EventTravelAdditionalInformation | null;
  loadIn: EventLoadInAdditionalInformation | null;
  promo: EventPromoAdditionalInformation | null;
  hotel: EventHotelAdditionalInformation | null;
  show: EventShowAdditionalInformation | null;
}

export interface EventTemplateItem {
  eventTypeId: string;
  startDate: string;
  endDate: string;
  timezoneId: string;
  eventDetails?: EventDetails | null;
  additionalInformation?: EventAdditionalInformation | null;
  notes: string | null;
  visibleToAll: boolean | null;
  nextDay: boolean | null;
  workspaceMemberIds?: string[] | null;
  groupNames?: string[] | null;
}

export interface EventTemplateVersion {
  id: string;
  currentVersion: number;
  name: string;
  description?: object;
  categoryId?: object;
  events: EventTemplateItem[];
  modifiedByUserId: string;
  /** @format date-time */
  createdAt: string;
  updatedAt: object;
}

export interface EventTemplateDto {
  id: string;
  artistId: string;
  categoryId: string | null;
  name: string;
  description: string | null;
  currentVersion: string | null;
  events: EventTemplateItem[];
  versions: EventTemplateVersion[];
  /** @format date-time */
  createdAt: string;
  updatedAt: string | null;
}

export interface EventTemplatesDto {
  eventTemplates: EventTemplateDto[];
}

export interface UpdateEventTemplateDto {
  categoryId?: string;
  /**
   * The ID country from countries table in schema.ts, not the code
   * @example "123e4567-e89b-12d3-a456-426614174000"
   */
  defaultCountryId?: string;
  name?: string;
  description?: string;
  defaultState?: string;
  defaultCity?: string;
  defaultStreetAddress?: string;
  defaultZipCode?: string;
  events?: EventTemplateItem[];
}

export interface CopyEventTemplateToArtistDto {
  artistId: string;
}

export interface VenueFormQuestion {
  answerType: "text" | "file" | null;
  question: string;
  answer: string | null;
  venueSubmissionFileId: string | null;
  file: UploadedFileKeyDto | null;
}

export interface CreateArtistVenueFormDto {
  name: string;
  questions: VenueFormQuestion[];
}

export interface ArtistVenueFormDto {
  id: string;
  artistId: string;
  name: string;
  questions: VenueFormQuestion[];
  createdAt: string;
  updatedAt: string | null;
}

export interface ArtistVenueFormsDto {
  artistVenueForms: ArtistVenueFormDto[];
}

export interface UpdateArtistVenueFormDto {
  name?: string;
  questions?: VenueFormQuestion[];
}

export interface CopyVenueFormToArtistDto {
  artistId: string;
}

export interface CreateTourDto {
  name: string;
  posterKey: string;
  workspaceId: string;
  artistId: string;
  /** @format date-time */
  startsAt: string;
  /** @format date-time */
  endsAt: string;
}

export interface TourDto {
  id: string;
  name: string;
  posterKey: string | null;
  startsAt: string | null;
  endsAt: string | null;
  workspaceId: string;
  artistId: string;
  archived: boolean;
}

export interface TourArtistDto {
  id: string;
  name: string;
  logoKey: string | null;
  posterKey: string | null;
  hexColorCode: string | null;
  archived: boolean;
}

export interface TourWithRoleAndArtistDto {
  id: string;
  name: string;
  posterKey: string | null;
  startsAt: string | null;
  endsAt: string | null;
  workspaceId: string;
  artistId: string;
  archived: boolean;
  personallyArchived: boolean;
  isArchivedForCurrentUser: boolean;
  artist: TourArtistDto;
  role: "TOUR_MEMBER" | "TOUR_MANAGER" | "TOUR_OWNER" | "VENDOR" | "TOUR_LEAD";
}

export interface TourWithArtistDto {
  id: string;
  name: string;
  posterKey: string | null;
  startsAt: string | null;
  endsAt: string | null;
  workspaceId: string;
  artistId: string;
  archived: boolean;
  personallyArchived: boolean;
  isArchivedForCurrentUser: boolean;
  artist: TourArtistDto;
}

export interface ToursWithArtistDto {
  tours: TourWithArtistDto[];
}

export interface UpdateTourDto {
  name?: string;
  posterKey?: string;
  workspaceId?: string;
  artistId?: string;
  /** @format date-time */
  startsAt?: string;
  /** @format date-time */
  endsAt?: string;
}

export interface TourPersonnelUserDto {
  id: string;
  email: string;
  firstName: string | null;
  lastName: string | null;
  avatarKey: string | null;
  phoneNumber: string | null;
  jobTitle: string | null;
}

export interface TourPersonnelDto {
  id: string;
  tourId: string;
  workspaceMemberId: string;
  roleId: string;
  sharePersonalInfo: boolean;
  createdAt: string;
  updatedAt: string | null;
  user: TourPersonnelUserDto;
}

export interface TourPersonnelArrayDto {
  tourPersonnel: TourPersonnelDto[];
}

export interface TourPendingInvitationDto {
  id: string;
  email: string;
  roleId: string;
  role: string;
  createdAt: string;
  updatedAt: string | null;
}

export interface TourPendingInvitationsDto {
  pendingInvitations: TourPendingInvitationDto[];
}

export interface Person {
  /** @example "user@example.com" */
  email: string;
  /** @example "role_id_123" */
  roleId: string;
}

export interface CreateTourPersonnelDto {
  people: Person[];
}

export interface UpdateTourPersonnelDto {
  workspaceMemberId?: string;
  tourId?: string;
  roleId: string;
  title?: string;
}

export interface UploadTourFileDto {
  fileType: "poster";
  workspaceId: string;
}

export interface DeleteTourFileDto {
  fileType: "poster";
  workspaceId: string;
}

export interface UpdateShareInformationConsentDto {
  allow: boolean;
}

export interface VenueDto {
  /** Email of the venue */
  venueEmail: string;
  /** Name of the venue */
  venueName: string;
}

export interface CreateVenueFormSubmissionDto {
  venueFormId?: string;
  /** Array of venues with their emails and names */
  venues: VenueDto[];
  questions: VenueFormQuestion[];
  /** Custom email body with {{submission_link}} placeholder */
  emailBody: string;
}

export interface SubmissionVenueDto {
  firstName: string | null;
  lastName: string | null;
  email: string;
}

export interface VenueFormSubmissionDto {
  id: string;
  tourId: string;
  venueFormId: string | null;
  /** email of user being the venue */
  venueEmail: string;
  isSubmitted: boolean;
  questions: VenueFormQuestion[];
  venue: SubmissionVenueDto;
  createdAt: string;
  updatedAt: string | null;
  submittedAt: string | null;
}

export interface VenueFormSubmissionsDto {
  venueFormSubmissions: VenueFormSubmissionDto[];
}

export interface Measurements {
  clothesCutPreference?: ("male" | "female" | "unisex")[];
  shirtSize?: string;
  casualPantsSize?: string;
  chestSize: string;
  waistSize: string;
  hipsSize?: string;
  inseamSize: string;
  sleeveLength?: string;
  neckSize?: string;
  shoeSize?: string;
}

export interface EducationalInformation {
  highestLevelOfEducation: string;
  degreeType: string;
  yearsObtained: string;
  institution: string;
}

export interface PersonalDocuments {
  headshotKey?: string;
  covidVaccinationKey?: string;
  driversLicenseKey?: string;
  w9Key?: string;
}

export interface DietaryInformation {
  dietaryRestrictions?: string[];
  materialAllergies?: string;
  medicinalAndNutritionalAllergies?: string;
}

export interface SocialMediaOtherLink {
  label?: string;
  url?: string;
}

export interface SocialMediaLinks {
  instagram?: string;
  tiktok?: string;
  linkedin?: string;
  facebook?: string;
  other?: SocialMediaOtherLink;
}

export interface CountriesPersonalDetailsCitizenshipDto {
  id: string;
}

export interface PersonalDetailDto {
  id: string;
  userId: string;
  completeLegalName: string | null;
  jobTitle: string | null;
  preferredName: string | null;
  gender: string | null;
  birthCity: string | null;
  birthCountryId: string | null;
  birthCountryName: string | null;
  phoneNumber: string | null;
  measurements: Measurements | null;
  educationalInformation: EducationalInformation | null;
  personalDocuments: PersonalDocuments | null;
  dietaryInformation: DietaryInformation | null;
  socialMediaLinks: SocialMediaLinks | null;
  addresses: AddressDto[] | null;
  citizenship: CountriesPersonalDetailsCitizenshipDto[] | null;
  createdAt: string;
  updatedAt: string | null;
  birthDate: string | null;
}

export interface UpdatePersonalDetailDto {
  completeLegalName?: string;
  preferredName?: string;
  jobTitle?: string;
  gender?: string;
  birthCity?: string;
  birthCountryId?: string;
  /** @format date-time */
  birthDate?: string;
  phoneNumber?: string;
  measurements?: Measurements;
  educationalInformation?: EducationalInformation;
  personalDocuments?: PersonalDocuments;
  dietaryInformation?: DietaryInformation;
  socialMediaLinks?: SocialMediaLinks;
  addressIds?: string[];
}

export interface CreateAddressDto {
  countryId: string;
  streetAddress: string;
  city: string;
  state?: string;
  zipCode?: string;
}

export interface PersonalDocumentDto {
  documentType: "headshot" | "covidVaccination" | "driversLicense" | "w9";
}

export interface DeletePersonalDocumentDto {
  documentType: "headshot" | "covidVaccination" | "driversLicense" | "w9";
}

export interface CreateUserCitizenshipDto {
  countryIds: string[];
}

export interface CreateTourPersonnelRoleDto {
  role: string;
}

export interface TourPersonnelRoleDto {
  id: string;
  role: string;
  createdAt: string;
  updatedAt: string | null;
}

export interface TourPersonnelRolesDto {
  tourPersonnelRoles: TourPersonnelRoleDto[];
}

export interface UpdateTourPersonnelRoleDto {
  role?: string;
}

export interface ClearNumbers {
  redressNumber: string;
  knownTravelerNumber: string;
}

export interface AirlineFrequentFliers {
  airline: string;
  flyerNumber: string;
}

export interface Passports {
  passportKey: string | null;
  passportNumber: string;
  issueDate: string;
  expirationDate: string;
  issuingCountryId: string;
}

export interface TravellingDetailDto {
  id: string;
  userId: string;
  homeAirport: string | null;
  seatPreference: ("aisle" | "window" | "middle")[];
  roomType: ("single" | "double" | "king_room" | "studio" | "suite")[];
  clearNumbers: ClearNumbers[];
  airlineFrequentFliers: AirlineFrequentFliers[];
  passports: Passports[];
  createdAt: string;
  updatedAt: string | null;
  roomFacilities: "smoking" | "non_smoking";
}

export interface UpdateTravellingDetailDto {
  homeAirport?: string;
  seatPreference?: ("aisle" | "window" | "middle")[];
  roomType?: ("single" | "double" | "king_room" | "studio" | "suite")[];
  clearNumbers?: ClearNumbers[];
  airlineFrequentFliers?: AirlineFrequentFliers[];
  passports?: Passports[];
  roomFacilities?: "smoking" | "non_smoking";
}

export interface AddPassportDto {
  passportNumber: string;
  issueDate: string;
  expirationDate: string;
  issuingCountryId: string;
}

export interface DeletePassportDto {
  passportNumber: string;
}

export interface CreateEmergencyContactDto {
  firstName: string;
  lastName: string;
  relation: string;
  email: string;
  phoneNumber: string;
  address: CreateAddressDto;
}

export interface EmergencyContactDto {
  id: string;
  userId: string;
  addressId: string;
  firstName: string | null;
  lastName: string | null;
  relation: string | null;
  email: string | null;
  phoneNumber: string | null;
  createdAt: string;
  updatedAt: string | null;
  address: AddressDto;
}

export interface EmergencyContactsDto {
  emergencyContacts: EmergencyContactDto[];
}

export interface UpdateEmergencyContactDto {
  firstName?: string;
  lastName?: string;
  relation?: string;
  email?: string;
  phoneNumber?: string;
  address: UpdateAddressDto;
}

export interface AdminUsersListDto {
  users: UserDto[];
  page: number;
  limit: number;
  total: number;
  totalPages: number;
}

export interface StripeSubscriptionDto {
  id: string;
  userId: string;
  sponsorId: string;
  stripeSubscriptionId: string;
  stripePriceId: string;
  stripeProductId: string;
  status: string;
  /** @format date-time */
  periodStart: string;
  /** @format date-time */
  periodEnd: string;
  interval: string;
  pausedUntil: string | null;
  cancelsAt: string | null;
  metadata: object;
  createdAt: string;
  updatedAt: string | null;
}

export interface AdminUserDetailsDto {
  user: UserDto;
  personalDetails: PersonalDetailDto | null;
  travellingDetails: TravellingDetailDto | null;
  emergencyContacts: EmergencyContactDto[];
  subscriptions: StripeSubscriptionDto[];
}

export interface ToursDto {
  tours: TourDto[];
}

export interface CreateEventTypeV1Dto {
  name: string;
}

export interface EventTypeV1Dto {
  id: string;
  name: string;
  createdAt: string;
  updatedAt: string | null;
}

export interface EventsV1Dto {
  /**
   * Events grouped by date
   * @example {"2024-04-12":[{"id":"event1"},{"id":"event2"}],"2024-04-13":[]}
   */
  events: Record<string, EventV1Dto[]>;
}

export interface StripeSubscriptionsDto {
  subscriptions: StripeSubscriptionDto[];
}

export interface PauseStripeSubscriptionDto {
  stripeSubscriptionId: string;
  /** @format date-time */
  pausedUntil?: string;
}

export interface ResumeStripeSubscriptionDto {
  stripeSubscriptionId: string;
}

export interface CancelStripeSubscriptionDto {
  stripeSubscriptionId: string;
}

export interface IndustryFeedItemDto {
  id: string;
  domain: "News" | "Opportunity" | "Information";
  source:
    | "Event Industry News"
    | "Music Business Worldwide"
    | "SoundGirls"
    | "Billboard"
    | "Live Nation"
    | "Ticketmaster"
    | "Backline.care"
    | "Vision for Sustainable Events"
    | "A Greener Future"
    | "LASSO"
    | "manual";
  origin: "manual" | "synced";
  contentType?: "internal" | "external" | null;
  externalId: string;
  title: string;
  url?: string | null;
  summary?: string | null;
  description?: string | null;
  publishedAt: string;
  imageUrl?: string | null;
  author?: string | null;
  sourceCategory?: string | null;
  location?: string | null;
}

export interface IndustryFeedSourceFailureDto {
  source:
    | "Event Industry News"
    | "Music Business Worldwide"
    | "SoundGirls"
    | "Billboard"
    | "Live Nation"
    | "Ticketmaster"
    | "Backline.care"
    | "Vision for Sustainable Events"
    | "A Greener Future"
    | "LASSO";
  status: "success" | "failed";
  lastAttemptAt: string;
  lastSuccessAt?: string | null;
}

export interface IndustryFeedListResponseDto {
  /**
   * @max 100
   * @default 20
   */
  limit: number;
  nextOffset: number | null;
  items: IndustryFeedItemDto[];
  sourceFailures: IndustryFeedSourceFailureDto[];
}

export interface CreateIndustryFeedAdminItemDto {
  domain: "News" | "Opportunity" | "Information";
  contentType: "internal" | "external";
  title: string;
  description: string;
  /** @format date-time */
  publishedAt: string;
  url?: string | null;
  imageUrl?: string;
  author?: string;
  location?: string;
}

export interface FileKeyDto {
  key: string;
}

export interface UploadedFileDto {
  url: string;
}

export interface FileKeysDto {
  /** @maxItems 500 */
  keys: string[];
}

export interface BulkDownloadUrlItemDto {
  key: string;
  url?: string;
  error?: string;
}

export interface DuplicateEventV1Dto {
  /** @example "2025-03-01" */
  initialDate: string;
  /** @example "2025-03-01" */
  targetDate: string;
  tourId: string;
  /** @example "America/Los_Angeles" */
  timezone: string;
  templateId?: string | null;
}

export type Boolean = object;

export interface CreateEventV1Dto {
  eventTypeId: string;
  countryId: string;
  state: string;
  city: string;
  nextDay?: Boolean;
  visibleToAll?: Boolean;
  isTbd?: boolean;
  isTentative?: boolean;
  zipCode?: string;
  streetAddress?: string;
  eventDetails?: EventDetails;
  additionalInformation?: EventAdditionalInformation;
  notes?: string;
  /** @format date-time */
  startDate: string;
  /** @format date-time */
  endDate: string;
  timezoneId: string;
}

export interface EventProviderDto {
  id: string;
  workspaceId: string;
  contactName: object;
  email: string | null;
  title: string | null;
  phoneNumber: string | null;
  address: AddressDto;
  createdAt: string;
  updatedAt: string | null;
}

export interface EventPersonnel {
  id: string;
  userId: string | null;
  roleId: string;
  email: string | null;
}

export interface Group {
  id: string;
  eventPersonnelId: string;
  eventPersonnelRoleId: string;
  personnel: EventPersonnel[];
}

export interface EventV1Dto {
  id: string;
  tourId: string;
  eventTypeId: string;
  countryId: string;
  state: string;
  city: string;
  visibleToAll: boolean;
  nextDay: boolean;
  isTbd: boolean;
  isTentative: boolean;
  eventDetails: EventDetails | null;
  eventProvider: EventProviderDto | null;
  startDate: string | null;
  endDate: string | null;
  createdAt: string;
  updatedAt: string | null;
  deletedAt: string | null;
  additionalInformation: EventAdditionalInformation | null;
  notes: string | null;
  eventPersonnel: EventPersonnel[];
  streetAddress: string | null;
  zipCode: string | null;
  groups: Group[] | null;
  timezoneId: string | null;
  templateId: string | null;
  templateVersion: number | null;
  multiLeg: string | null;
}

export interface EventTypesV1Dto {
  eventTypes: EventTypeV1Dto[];
}

export interface UpdateEventV1Dto {
  eventTypeId?: string;
  countryId?: string;
  state?: string;
  city?: string;
  nextDay?: Boolean;
  visibleToAll?: Boolean;
  isTbd?: boolean;
  isTentative?: boolean;
  zipCode?: string;
  streetAddress?: string;
  eventDetails?: EventDetails;
  additionalInformation?: EventAdditionalInformation;
  notes?: string;
  /** @format date-time */
  startDate?: string;
  /** @format date-time */
  endDate?: string;
  timezoneId?: string;
  /** @deprecated */
  id?: string;
  /** Multi-leg journey group key */
  multiLeg?: string;
}

export interface CreateEventPersonnelDto {
  people: Person[];
}

export interface PersonnelGroup {
  groupId: string;
  roleId: string;
}

export interface CreateEventPersonnelGroupDto {
  groups: PersonnelGroup[];
}

export interface EventPersonnelDto {
  eventPersonnel: EventPersonnel[];
  groups: Group[] | null;
}

export interface UpdateEventPersonnelDto {
  eventId: string;
  eventPersonnelRoleId: string;
}

export interface CreateGuestListSubmissionDto {
  firstName: string;
  lastName: string;
  phoneNumber: string;
  email?: string;
  deliveryMethod:
    | "WILL_CALL"
    | "BOX_OFFICE"
    | "FRONT_ENTRANCE"
    | "BACK_ENTRANCE"
    | "SHIPPED"
    | "HAND_DELIVER"
    | "OTHER";
  quantity: number;
}

export interface UserGuestListSubmissionDto {
  id: string;
  eventId: string;
  firstName: string;
  lastName: string;
  phoneNumber: string;
  email: string | null;
  quantity: number;
  status: string;
  deliveryMethod: string;
  notes: string | null;
  seatAssignments: string | null;
  dateRequested: string | null;
  createdAt: string;
  updatedAt: string | null;
}

export interface UpdateGuestListSubmissionDto {
  deliveryMethod?:
    | "WILL_CALL"
    | "BOX_OFFICE"
    | "FRONT_ENTRANCE"
    | "BACK_ENTRANCE"
    | "SHIPPED"
    | "HAND_DELIVER"
    | "OTHER";
  status?: "PENDING" | "DECLINED" | "APPROVED";
  priority?: "LOW" | "MEDIUM" | "HIGH";
  notes?: string;
  seatAssignment?: string;
  quantity?: number;
}

export interface SubmissionUser {
  userId: string;
  firstName: string | null;
  lastName: string | null;
}

export interface ManagerGuestListSubmissionDto {
  id: string;
  eventId: string;
  firstName: string;
  lastName: string;
  phoneNumber: string;
  email: string | null;
  quantity: number;
  status: string;
  deliveryMethod: string;
  priority: string;
  notes: string | null;
  seatAssignments: string | null;
  dateRequested: string | null;
  requestedBy: SubmissionUser;
  createdAt: string;
  updatedAt: string | null;
}

export interface GuestListSubmissionsDto {
  managerSubmissions: ManagerGuestListSubmissionDto[];
  userSubmissions: UserGuestListSubmissionDto[];
}

export interface EventsV2Dto {
  /**
   * Events grouped by date
   * @example {"2024-04-12":[{"id":"event1"},{"id":"event2"}],"2024-04-13":[]}
   */
  events: Record<string, EventV2Dto[]>;
}

export interface EventV2Dto {
  id: string;
  tourId: string;
  eventTypeId: string;
  countryId: string;
  state: string;
  city: string;
  visibleToAll: boolean;
  nextDay: boolean;
  isTbd: boolean;
  isTentative: boolean;
  eventDetails: EventDetails | null;
  providerId: string | null;
  startDate: string | null;
  endDate: string | null;
  createdAt: string;
  updatedAt: string | null;
  deletedAt: string | null;
  additionalInformation: EventAdditionalInformation | null;
  notes: string | null;
  streetAddress: string | null;
  zipCode: string | null;
  timezoneId: string | null;
  templateId: string | null;
  templateVersion: number | null;
  multiLeg: string | null;
}

export interface CreateWithTemplateDto {
  templateId: string;
  /** @example "2025-03-01" */
  targetDate: string;
}

export interface OverrideWithTemplateDto {
  templateId: string;
  /** @example "2025-03-01" */
  targetDate: string;
  /**
   * The timezone of the events we will override, like events in LA
   * @example "America/Los_Angeles"
   */
  timezoneId: string;
}

export interface CreateMultiLegEventDto {
  eventTypeId: string;
  countryId: string;
  state: string;
  city: string;
  nextDay?: Boolean;
  visibleToAll?: Boolean;
  isTbd?: boolean;
  isTentative?: boolean;
  zipCode?: string;
  streetAddress?: string;
  eventDetails?: EventDetails;
  additionalInformation?: EventAdditionalInformation;
  notes?: string;
  /** @format date-time */
  startDate: string;
  /** @format date-time */
  endDate: string;
  timezoneId: string;
  /** Multi-leg journey group key */
  multiLeg?: string;
}

export interface CreateMultiLegEventsDto {
  /** Multi-leg journey group key */
  multiLeg?: string;
  events: CreateMultiLegEventDto[];
}

export interface MultiLegEventsV2Dto {
  multiLegEvents: EventV2Dto[];
}

export interface SendEventReminderDto {
  /**
   * Custom reminder message. If not provided, a default message will be used.
   * @maxLength 500
   */
  customMessage?: string;
}

export interface SendNotificationDto {
  title: string;
  body: string;
  data: object;
  deviceIds: string[];
}

export interface CreateMobileDeviceDto {
  deviceToken: string;
}

export interface RevokeMobileDeviceDto {
  deviceToken: string;
}

export interface CreateEventReminderDto {
  eventId: string;
  reminderType: "team" | "personal";
  /** Target user ID for personal reminders. Required for personal type. */
  targetUserId?: string;
  title: string;
  description?: string;
  /**
   * Minutes before event start to send the reminder
   * @min 1
   * @max 525600
   */
  minutesBeforeEvent: number;
}

export interface EventReminderDto {
  id: string;
  eventId: string;
  tourId: string;
  createdByUserId: string;
  targetUserId?: object;
  reminderType: "team" | "personal";
  title: string;
  description?: object;
  /** @format date-time */
  scheduledFor: string;
  status: "pending" | "sent" | "failed" | "cancelled";
  notificationSentAt?: object;
  retryCount: number;
  maxRetries: number;
  lastError?: object;
  /** @format date-time */
  createdAt: string;
  updatedAt?: object;
}

export interface EventRemindersDto {
  reminders: EventReminderDto[];
}

export interface UpdateEventReminderDto {
  reminderType?: "team" | "personal";
  /** Target user ID for personal reminders */
  targetUserId?: string;
  title?: string;
  description?: string;
  /**
   * Minutes before event start to send the reminder
   * @min 1
   * @max 525600
   */
  minutesBeforeEvent?: number;
  status?: "pending" | "sent" | "failed" | "cancelled";
}

export interface SendEmailDto {
  emails: string[];
  subject: string;
  emailBody: string;
}

export interface CreateEventProviderDto {
  workspaceId: string;
  contactName: string;
  email: string;
  title: string;
  phoneNumber: string;
  address: CreateAddressDto;
}

export interface UpdateEventProviderDto {
  contactName?: string;
  email?: string;
  title?: string;
  phoneNumber?: string;
  workspaceId: string;
  address: UpdateAddressDto;
}

export interface EventProvidersDto {
  eventProviders: EventProviderDto[];
}

export interface DayTagDto {
  id: string;
  workspaceId: string | null;
  name: string;
  createdAt: string;
  updatedAt: string | null;
}

export interface DayTagsDto {
  dayTags: DayTagDto[];
}

export interface CreateDayTagDto {
  workspaceId: string;
  name: string;
}

export interface TourDayLocationDetails {
  countryId: string;
  state: string;
  city: string;
  timezoneId: string;
  zipCode?: string;
  streetAddress?: string;
}

export interface DayTag {
  name: string;
}

export interface TourDayNoteDto {
  id: string;
  tourDayId: string;
  body: string;
  createdAt: string;
  updatedAt: string | null;
}

export interface TourDayDto {
  id: string;
  tourId: string;
  dayTagId: string;
  location: string | null;
  locationDetails: TourDayLocationDetails | null;
  date: string;
  createdAt: string;
  updatedAt: string | null;
  dayTag: DayTag;
  note: TourDayNoteDto;
}

export interface TourDaysDto {
  tourDays: TourDayDto[];
}

export interface CreateTourDayDto {
  workspaceId: string;
  dayTagId: string;
  location?: string | null;
  locationDetails?: TourDayLocationDetails | null;
  date: string;
}

export interface CreatedTourDayDto {
  id: string;
  tourId: string;
  dayTagId: string;
  location: string | null;
  locationDetails: TourDayLocationDetails | null;
  date: string;
  createdAt: string;
  updatedAt: string | null;
}

export interface CreateTourDayNoteDto {
  body: string;
  tourDayId: string;
}

export interface UpdateTourDayNoteDto {
  body?: string;
  tourDayId?: string;
}

export interface EventPersonnelRoleDto {
  id: string;
  role: string;
  createdAt: string;
  updatedAt: string | null;
}

export interface EventPersonnelRolesDto {
  eventPersonnelRoles: EventPersonnelRoleDto[];
}

export interface TableColumnsDto {
  /**
   * Columns grouped by table name
   * @example {"table1":["column1","column2","column3"],"table2":["column4","column5"]}
   */
  tableColumns: Record<string, string[]>;
}

export interface TableColumnsSupplementalQuestionsDto {
  /**
   * Supplemental questions grouped by country code
   * @example {"DE":[{"id":"question3-id","body":"B question"}],"PL":[{"id":"question2-id","body":"A question"},{"id":"question1-id","body":"C question"}],"SK":[{"id":"question2-id","body":"A question"}]}
   */
  supplementalQuestions: Record<
    string,
    {
      id?: string;
      body?: string;
    }[]
  >;
}

export interface CreateReportTemplateDto {
  workspaceId: string;
  name: string;
  columns: Record<string, string[]>;
  supplementalQuestions?: Record<
    string,
    {
      id?: string;
      body?: string;
    }[]
  >;
}

export interface ReportTemplateDto {
  workspaceId: object;
  name: string;
  columns: Record<string, string[]>;
  supplementalQuestions: Record<
    string,
    {
      id?: string;
      body?: string;
    }[]
  >;
}

export interface ReportTemplatesDto {
  reportTemplates: ReportTemplateDto[];
}

export interface CreateReportDto {
  reportTemplateId: string | null;
  workspaceId: string;
  tourId: string;
  people?: string[] | null;
  from?: string | null;
  to?: string | null;
  columnsOrder: string[];
  columns: Record<string, string[]>;
  supplementalQuestions?: Record<
    string,
    {
      id?: string;
      body?: string;
    }[]
  >;
}

export interface CreatedReportDto {
  reportTemplateId: string | null;
  workspaceId: string;
  columnsOrder: string[];
  content: object;
}

export interface ReportsDto {
  reports: CreatedReportDto[];
}

export interface CreateGroupDto {
  name: string;
}

export interface GroupMemberUserDto {
  id: string;
  firstName: string | null;
  lastName: string | null;
  phoneNumber: string | null;
  email: string;
  avatarKey: string | null;
}

export interface GroupMemberDto {
  id: string;
  tourPersonnelId: string;
  groupId: string;
  tourPersonnelRoleId: string;
  createdAt: string;
  updatedAt: string | null;
  user: GroupMemberUserDto;
}

export interface GroupDto {
  id: string;
  name: string;
  tourId: string;
  createdAt: string;
  updatedAt: string | null;
  groupMembers: GroupMemberDto[];
}

export interface GroupsDto {
  groups: GroupDto[];
}

export interface UpdateGroupDto {
  name?: string;
}

export interface CreateGroupMembersDto {
  people: Person[];
}

export interface GroupMembersArrayDto {
  groupMembers: GroupMemberDto[];
}

export interface RiderTypeDto {
  id: string;
  name: string;
  createdAt: string;
  updatedAt?: string | null;
}

export interface RiderTypesDto {
  riderTypes: RiderTypeDto[];
}

export interface CreateRiderDto {
  riderTypeId: string;
  name: string;
  tourId: string;
  artistId: string;
}

export interface RiderVenue {
  accessPreferences?: string | null;
  accessQuestions?: string | null;
  loadInPreferences?: string | null;
  loadInQuestions?: string | null;
  securityRequirements?: string | null;
}

export interface RiderTransportation {
  semis?: string | null;
  tourBuses?: string | null;
  boxTrucks?: string | null;
  suvs?: string | null;
  personalVehicles?: string | null;
}

export interface RiderTechnical {
  stageSize?: string | null;
  stagePlotKey?: string | null;
  riggingPlotKey?: string | null;
  scenicKey?: string | null;
  lightingPlotKey?: string | null;
  risers?: string | null;
  powerNeeds?: string | null;
  backDrop?: string | null;
  videoRequirements?: string | null;
  carryingVideo?: boolean | null;
  lightingSystemRequirements?: string | null;
  carryingLighting?: boolean | null;
  audioRequirements?: string | null;
  carryingAudio?: boolean | null;
  sfxRequirements?: string | null;
  backlineRequirements?: string | null;
}

export interface RiderHospitality {
  greenRoomOfficeNeeds?: string | null;
  preferredVipAccommodations?: string | null;
  preferredLaundry?: string | null;
  preferredShowerAndRestrooms?: string | null;
  cateringPreferences?: string | null;
  hospitality?: string | null;
  handTowelsNeeded?: string | null;
  bathTowelsNeeded?: string | null;
  locationForTowels?: string | null;
  towelColor?: string | null;
}

export interface RiderMerch {
  travellingWithMerchSalesPreps?: boolean | null;
  preferToSellMerch?: boolean | null;
  travellingWithSponsorship?: boolean | null;
  sponsorship?: string | null;
  dailyObligationsForSponsorship?: boolean | null;
  sponsorshipObligations?: string | null;
  sponsorRequireFromVenue?: boolean | null;
  sponsorVenueRequirements?: string | null;
}

export interface RiderDto {
  id: string;
  riderTypeId: string;
  tourId: string;
  artistId: string;
  name: string;
  totalTourPartyNumber: object | null;
  riderVenue: RiderVenue | null;
  riderTransportation: RiderTransportation | null;
  riderTechnical: RiderTechnical | null;
  riderHospitality: RiderHospitality | null;
  riderMerch: RiderMerch | null;
  withSupportingAct: boolean;
}

export interface RidersDto {
  riders: RiderDto[];
}

export interface UpdateRiderDto {
  riderTypeId?: string;
  name?: string;
  tourId?: string;
  artistId?: string;
  totalTourPartyNumber?: number;
  riderVenue?: RiderVenue;
  riderTransportation?: RiderTransportation;
  riderTechnical?: RiderTechnical;
  riderHospitality?: RiderHospitality;
  riderMerch?: RiderMerch;
  withSupportingAct?: boolean;
}

export interface CreateRiderPersonnelDto {
  people: Person[];
}

export interface RiderPersonnelUserDto {
  id: string;
  email: string;
  firstName: string | null;
  lastName: string | null;
  avatarKey: string | null;
}

export interface RiderPersonnelDto {
  id: string;
  riderId: string;
  tourPersonnelId: string | null;
  createdAt: string;
  updatedAt: string | null;
  user: RiderPersonnelUserDto | null;
}

export interface RiderPersonnelArrayDto {
  riderPersonnel: RiderPersonnelDto[];
}

export interface CreateExternalRiderPersonnelDto {
  riderId: string;
  firstName?: string;
  lastName?: string;
  email?: string;
  phoneNumber?: string;
  position?: string;
  company?: string;
}

export interface ExternalRiderPersonnelDto {
  id: string;
  riderId: string;
  firstName: string | null;
  lastName: string | null;
  email: string | null;
  phoneNumber: string | null;
  position: string | null;
  company: string | null;
  createdAt: string;
  updatedAt: string | null;
}

export interface ExternalRiderPersonnelArrayDto {
  externalRiderPersonnel: ExternalRiderPersonnelDto[];
}

export interface UpdateExternalRiderPersonnelDto {
  firstName?: string;
  lastName?: string;
  email?: string;
  phoneNumber?: string;
  position?: string;
  company?: string;
}

export interface UploadRiderFileDto {
  fileType: "scenic" | "stagePlot" | "riggingPlot" | "lightingPlot";
}

export interface DeleteRiderFileDto {
  fileType: "scenic" | "stagePlot" | "riggingPlot" | "lightingPlot";
}

export interface CreateRiderLaborDto {
  riderId: string;
  riderLaborTypeId: string;
  quantity: number;
  /** @format date-time */
  startDate: string;
  /** @format date-time */
  endDate: string;
}

export interface RiderLaborDto {
  id: string;
  riderId: string;
  riderLaborTypeId: string;
  quantity: number;
  startDate: string;
  endDate: string;
  createdAt: string;
  updatedAt: string | null;
}

export interface RiderLaborsDto {
  riderLabors: RiderLaborDto[];
}

export interface UpdateRiderLaborDto {
  riderLaborTypeId?: string;
  quantity?: number;
  /** @format date-time */
  startDate?: string;
  /** @format date-time */
  endDate?: string;
}

export interface CreateRiderSupportingActDto {
  riderId: string;
  complementaryNotes?: string;
}

export interface SupportingActPersonnelDto {
  id: string;
  supportingActId: string;
  firstName: string | null;
  lastName: string | null;
  email: string | null;
  phoneNumber: string | null;
  position: string | null;
  company: string | null;
  createdAt: string;
  updatedAt: string | null;
}

export interface RiderSupportingActDto {
  id: string;
  riderId: string;
  complementaryNotes: string | null;
  logoKey: string | null;
  riderKey: string | null;
  stagePlotKey: string | null;
  createdAt: string;
  updatedAt: string | null;
  personnel: SupportingActPersonnelDto[];
}

export interface RiderSupportingActsDto {
  riderSupportingActs: RiderSupportingActDto[];
}

export interface UpdateRiderSupportingActDto {
  complementaryNotes?: string;
}

export interface UploadRiderSupportingActFileDto {
  fileType: "logo" | "rider" | "stagePlot";
}

export interface DeleteRiderSupportingActFileDto {
  fileType: "logo" | "rider" | "stagePlot";
}

export interface CreateSupportingActPersonnelDto {
  supportingActId: string;
  firstName?: string;
  lastName?: string;
  email?: string;
  phoneNumber?: string;
  position?: string;
  company?: string;
}

export interface SupportingActPersonnelArrayDto {
  supportingActPersonnel: SupportingActPersonnelDto[];
}

export interface UpdateSupportingActPersonnelDto {
  firstName?: string;
  lastName?: string;
  email?: string;
  phoneNumber?: string;
  position?: string;
  company?: string;
}

export interface CreatePersonalEventDto {
  /** @format date-time */
  startTime: string;
  /** @format date-time */
  endTime: string;
  name: string;
  notes?: string;
  timezone?: string;
  streetAddress?: string;
  city?: string;
  state?: string;
  countryId?: string;
}

export interface PersonalEventDto {
  id: string;
  userId: string;
  name: string;
  notes: string | null;
  /** @format date-time */
  startTime: string;
  /** @format date-time */
  endTime: string;
  timezone: string | null;
  streetAddress: string | null;
  city: string | null;
  state: string | null;
  countryId: string | null;
  createdAt: string;
  updatedAt: string | null;
}

export interface PersonalEventsDto {
  personalEvents: PersonalEventDto[];
}

export interface UpdatePersonalEventDto {
  /** @format date-time */
  startTime?: string;
  /** @format date-time */
  endTime?: string;
  name?: string;
  notes?: string;
  timezone?: string;
  streetAddress?: string;
  city?: string;
  state?: string;
  countryId?: string;
}

export interface CreateChatRoomDto {
  tourId: string | null;
  name: string;
  userIds?: string[];
}

export interface ChatRoomMemberDto {
  id: string;
  chatRoomId: string;
  userId: string;
  firstName: string | null;
  lastName: string | null;
  email: string | null;
  avatarKey: string | null;
  phoneNumber: string | null;
  lastVisitAt: string;
  createdAt: string;
  updatedAt: string | null;
}

export interface ChatRoomDto {
  id: string;
  tourId: string | null;
  ownerId: string;
  name: string;
  archivedAt: string | null;
  createdAt: string;
  updatedAt: string | null;
  members: ChatRoomMemberDto[];
}

export interface ChatRoomsDto {
  chatRooms: ChatRoomDto[];
}

export interface UnreadMessageDto {
  chatRoomId: string;
  count: number;
}

export interface UnreadMessagesDto {
  unreadMessages: UnreadMessageDto[];
}

export interface UpdateChatRoomDto {
  tourId?: string | null;
  name?: string;
  userIds?: string[];
}

export interface CreateChatRoomMembersDto {
  people: Person[];
}

export interface CreateMessageDto {
  body?: string | null;
}

export interface SenderDto {
  firstName: string | null;
  lastName: string | null;
  email: string;
  avatarKey: string | null;
}

export interface MessageAttachmentDto {
  id: string;
  messageId: string;
  key: string;
  description: string | null;
  createdAt: string;
  updatedAt: string | null;
}

export interface MessageDto {
  id: string;
  senderId: string;
  sender: SenderDto;
  body: string | null;
  createdAt: string;
  updatedAt: string | null;
  attachments: MessageAttachmentDto[];
}

export interface MessagesDto {
  messages: MessageDto[];
}

export interface CreateAccommodationRoomDto {
  roomNumber: string;
}

export interface RoomMemberDto {
  id: string;
  userId: string;
  roomId: string;
  tourPersonnelId: string;
  firstName: string | null;
  lastName: string | null;
  email: string | null;
  avatarKey: string | null;
  checkIn: string;
  checkOut: string;
  createdAt: string;
  updatedAt: string | null;
}

export interface AccommodationRoomDto {
  id: string;
  eventId: string;
  roomNumber: string;
  createdAt: string;
  updatedAt: string | null;
  members: RoomMemberDto[];
}

export interface AccommodationRoomsDto {
  accommodationRooms: AccommodationRoomDto[];
}

export interface UpdateAccommodationRoomDto {
  roomNumber?: string;
}

export interface RoomPersonDto {
  /** @deprecated */
  email?: string;
  /** @deprecated */
  roleId?: string;
  tourPersonnelId: string;
  /** @format date-time */
  checkIn: string;
  /** @format date-time */
  checkOut: string;
}

export interface CreateRoomMembersDto {
  people: RoomPersonDto[];
}

export interface UpdateRoomMemberDto {
  /** @format date-time */
  checkIn: string;
  /** @format date-time */
  checkOut: string;
}

export interface CreateTourFileDto {
  folderId: string | null;
  orderIndex: number | null;
}

export interface CreatedTourFileDto {
  fileId: string;
  tourFileId: string;
}

export interface FileDto {
  id: string;
  name: string;
  key: string;
  userId: string;
  createdAt: string;
  updatedAt: string | null;
}

export interface TourFileDto {
  id: string;
  tourId: string;
  fileId: string;
  folderId?: string | null;
  orderIndex?: number | null;
  pinnedAt?: string | null;
  file: FileDto;
  tour: TourDto;
  artist: ArtistDto;
  createdAt: string;
  updatedAt: string | null;
}

export interface TourFolderDto {
  id: string;
  name: string;
  tourId: string;
  tourDayId: string | null;
  parentFolderId: string | null;
  createdAt: string;
  updatedAt: string | null;
}

export interface TourFilesDto {
  tourFiles: TourFileDto[];
  folders: TourFolderDto[];
}

export interface ReorderTourFileItemDto {
  tourFileId: string | null;
  folderId: string | null;
}

export interface ReorderTourFilesDto {
  order: ReorderTourFileItemDto[];
}

export interface UpdateTourFileDto {
  folderId?: string | null;
  pinned?: boolean;
}

export interface CreateSupplementalAnswerDto {
  body?: string | null;
  questionId: string;
}

export interface UpdateSupplementalAnswerDto {
  body?: string | null;
}

export interface SupplementalQuestionDto {
  id: string;
  body: string;
  createdAt: string;
  updatedAt: string | null;
}

export interface SupplementalAnswerDto {
  id: string;
  userId: string;
  questionId: string;
  question: SupplementalQuestionDto;
  body: string | null;
  fileId: string | null;
  file: FileDto | null;
  createdAt: string;
  updatedAt: string | null;
}

export interface SupplementalAnswersDto {
  /**
   * Answers grouped by country code
   * @example {"PL":[{"id":"id","userId":"userId","questionId":"questionId","question":{"id":"questionId","title":"Question 1","createdAt":"2024-07-11T10:00:00Z"},"body":"Answer body 1","fileId":"fileId","file":{"id":"fileOd","name":"File 1","key":"file1key","userId":"userId","createdAt":"2024-07-11T10:00:00Z","updatedAt":null},"createdAt":"2024-07-11T10:00:00Z","updatedAt":null}]}
   */
  answers: Record<string, SupplementalAnswerDto[]>;
}

export interface SupplementalQuestionsDto {
  supplementalQuestions: SupplementalQuestionDto[];
}

export interface CreateDayFileDto {
  tourDayId: string;
  tourFileIds: string[];
  tourId: string;
  folderId: string | null;
  orderIndex: number | null;
}

export interface DayFileDto {
  id: string;
  tourDayId: string;
  tourFileId: string;
  folderId: string | null;
  orderIndex: number | null;
  pinnedAt: string | null;
  tourFile: TourFileDto;
  createdAt: string;
  updatedAt: string | null;
}

export interface DayFilesDto {
  tourDayId: string;
  tourDay: TourDayDto;
  dayFiles: DayFileDto[];
  folders: TourFolderDto[];
}

export interface ReorderDayFileItemDto {
  tourDayFileId: string | null;
  folderId: string | null;
}

export interface ReorderDayFilesDto {
  order: ReorderDayFileItemDto[];
}

export interface UpdateDayFileDto {
  folderId?: string | null;
  pinned?: boolean;
}

export interface CreateRiderLaborTypeDto {
  name: string;
  tourId: string;
}

export interface RiderLaborTypeDto {
  id: string;
  name: string;
  tourId?: string | null;
  createdAt: string;
  updatedAt?: string | null;
}

export interface RiderLaborTypesDto {
  riderLaborTypes: RiderLaborTypeDto[];
}

export interface GeneralProductionTrackerContent {
  generalAdvanceSent?: boolean | null;
  techRiderSent?: boolean | null;
  hospitalitySent?: boolean | null;
  venueTechPackReceived?: boolean | null;
  date?: string | null;
  venue?: string | null;
  city?: string | null;
  loadInTime?: string | null;
  soundCheck?: string | null;
  changeOver?: string | null;
  setTime?: string | null;
  hardCurfew?: string | null;
  stageManagerContact?: string | null;
  festivalPmContact?: string | null;
}

export interface StagingProductionTrackerContent {
  stageName?: string | null;
  stageSize?: string | null;
  wings?: string | null;
  rollingRisers?: string | null;
}

export interface VideoProductionTrackerContent {
  upstageWall?: string | null;
  imagWalls?: string | null;
  sfx?: string | null;
  power?: string | null;
}

export interface LightingProductionTrackerContent {
  lightingAdvanceContact?: string | null;
  lxPlotReceived?: boolean | null;
  patchReceived?: boolean | null;
  sfx?: string | null;
  power?: string | null;
  networking?: string | null;
}

export interface AudioProductionTrackerContent {
  frequencyLicensesSent?: string | null;
  snake?: string | null;
  foxBoard?: string | null;
  monitors?: string | null;
  maxDb?: string | null;
  strict?: string | null;
  power?: string | null;
}

export interface LaborProductionTrackerContent {
  notes?: string | null;
  forklifts?: string | null;
  dock?: string | null;
  loadIn?: string | null;
}

export interface LoadInProductionTrackerContent {
  riggers?: string | null;
  forks?: string | null;
  loaders?: string | null;
  hands?: string | null;
  allDay?: string | null;
  showHands?: string | null;
  spotOps?: string | null;
}

export interface LoadOutProductionTrackerContent {
  riggers?: string | null;
  forks?: string | null;
  loaders?: string | null;
  hands?: string | null;
}

export interface ProductionTrackerContent {
  general: GeneralProductionTrackerContent;
  staging: StagingProductionTrackerContent;
  video: VideoProductionTrackerContent;
  lighting: LightingProductionTrackerContent;
  audio: AudioProductionTrackerContent;
  labor: LaborProductionTrackerContent;
  loadIn: LoadInProductionTrackerContent;
  loadOut: LoadOutProductionTrackerContent;
}

export interface CreateProductionTrackerDto {
  eventId: string;
  tourId: string;
  content: ProductionTrackerContent;
}

export interface ProductionTrackerDto {
  id: string;
  eventId: string;
  content: ProductionTrackerContent;
  createdAt: string;
  updatedAt: string | null;
}

export interface UpdateProductionTrackerDto {
  tourId: string;
  content: ProductionTrackerContent;
}

export interface FlightsInfoDto {
  flights: FlightInfoDto[];
}

export interface UserPassports {
  firstName: object;
  lastName: object;
  email: string;
  passports: Passports[];
}

export interface ExpiringPassportsDto {
  tourId: string;
  /** @format date-time */
  startDate: string;
  /** @format date-time */
  endDate: string;
  usersExpiringPassports: UserPassports[];
}

export interface QueryPlacesDto {
  textQuery: string;
}

export interface DisplayNameDto {
  text: string;
  languageCode: string;
}

export interface LocationDto {
  latitude: number;
  longitude: number;
}

export interface PlusCodeDto {
  globalCode: string;
  compoundCode: string;
}

export interface AddressComponentDto {
  types: string[];
  shortText: string;
  longText: string;
  languageCode: string;
}

export interface SubDestinationDto {
  name: string;
  id: string;
}

export interface PlaceDto {
  displayName: DisplayNameDto;
  name: string;
  location: LocationDto;
  utcOffsetMinutes: number;
  plusCode?: PlusCodeDto;
  addressComponents: AddressComponentDto[];
  formattedAddress: string;
  shortFormattedAddress: string;
  internationalPhoneNumber: string;
  websiteUri: string;
  types: string[];
  subDestinations?: SubDestinationDto[];
}

export interface GooglePlacesDto {
  places: PlaceDto[];
}

export interface PlaceLocationDto {
  latitude: number;
  longitude: number;
}

export interface GooglePlaceLocationDto {
  placeId: string;
  name: string;
  formattedAddress?: string;
  types?: string[];
  location?: PlaceLocationDto;
}

export interface GooglePlacesLocationsDto {
  places: GooglePlaceLocationDto[];
}

export interface QueryPlaceCoordinatesDto {
  placeId: string;
}

export interface GoogleTimezoneDto {
  dstOffset: number;
  rawOffset: number;
  status: string;
  timeZoneId: string;
  timeZoneName: string;
}

export interface QueryTravelTimeDto {
  origin: LatLngDto;
  destination: LatLngDto;
  /**
   * Departure time as ISO 8601 or timestamp
   * @format date-time
   */
  departureTime: string;
  computeAlternativeRoutes?: string | null;
}

export interface RoutePolylineDto {
  encodedPolyline: string;
}

export interface RouteDto {
  distanceMeters: number;
  duration: string;
  polyline?: RoutePolylineDto;
  routeToken?: string;
}

export interface GoogleTravelTimeDto {
  routes: RouteDto[];
}

export interface CreateRoadieRecDto {
  placeId: string;
  category:
    | "BREAKFAST"
    | "COFFEE_SHOPS"
    | "DINNER"
    | "AFTER_SHOW"
    | "BARS"
    | "ACTIVITIES"
    | "FLUFF_AND_FOLD"
    | "SHOPPING"
    | "RECORD_SHOPS"
    | "ROCK_DOCS"
    | "VOLUNTEER"
    | "HOTELS"
    | "TATTOOS"
    | "BARBERS"
    | "HAIR"
    | "PIERCING"
    | "SPA"
    | "FITNESS"
    | "OTHER";
}

export interface RoadieRecWithUpvotesDto {
  id: string;
  placeId: string;
  name: string;
  formattedAddress: string;
  lat: number;
  lng: number;
  category:
    | "BREAKFAST"
    | "COFFEE_SHOPS"
    | "DINNER"
    | "AFTER_SHOW"
    | "BARS"
    | "ACTIVITIES"
    | "FLUFF_AND_FOLD"
    | "SHOPPING"
    | "RECORD_SHOPS"
    | "ROCK_DOCS"
    | "VOLUNTEER"
    | "HOTELS"
    | "TATTOOS"
    | "BARBERS"
    | "HAIR"
    | "PIERCING"
    | "SPA"
    | "FITNESS"
    | "OTHER";
  /** Omitted from guest responses; a stable identifier is not released anonymously. */
  createdBy?: string;
  /** @format date-time */
  createdAt: string;
  openNow?: boolean;
  rating: object | null;
  priceLevel: object | null;
  photos?: string[];
  upvoteCount: number;
  viewerHasUpvoted: boolean;
}

export interface RoadieRecCreateResponseDto {
  alreadyAdded: boolean;
  recommendation: RoadieRecWithUpvotesDto;
}

export interface RoadieRecsDto {
  recommendations: RoadieRecWithUpvotesDto[];
  nextCursor: object | null;
}

export interface RoadieRecDetailDto {
  id: string;
  placeId: string;
  name: string;
  formattedAddress: string;
  lat: number;
  lng: number;
  category:
    | "BREAKFAST"
    | "COFFEE_SHOPS"
    | "DINNER"
    | "AFTER_SHOW"
    | "BARS"
    | "ACTIVITIES"
    | "FLUFF_AND_FOLD"
    | "SHOPPING"
    | "RECORD_SHOPS"
    | "ROCK_DOCS"
    | "VOLUNTEER"
    | "HOTELS"
    | "TATTOOS"
    | "BARBERS"
    | "HAIR"
    | "PIERCING"
    | "SPA"
    | "FITNESS"
    | "OTHER";
  /** Omitted from guest responses; a stable identifier is not released anonymously. */
  createdBy?: string;
  /** @format date-time */
  createdAt: string;
  openNow?: boolean;
  rating: object | null;
  priceLevel: object | null;
  photos?: string[];
  upvoteCount: number;
  viewerHasUpvoted: boolean;
  phone?: string;
  website?: string;
  hours?: string[];
}

export interface RoadieRecUpvoteDto {
  id: string;
  recommendationId: string;
  userId: string;
  /** @format date-time */
  createdAt: string;
}

export interface RoadieRecUpvoteResponseDto {
  alreadyUpvoted: boolean;
  upvote: RoadieRecUpvoteDto;
  upvoteCount: number;
  viewerHasUpvoted: boolean;
}

export interface ProductDto {
  id: string;
  object: string;
  active: boolean;
  description: object;
  images: string[];
  name: string;
}

export interface RecurringDto {
  interval: string;
  intervalCount: number;
}

export interface PriceDto {
  id: string;
  object: string;
  active: boolean;
  product: ProductDto;
  recurring: RecurringDto | null;
  type: string;
  unitAmount: number;
  unitAmountDecimal: string;
}

export interface PricesDto {
  data: PriceDto[];
  hasMore: boolean;
  url: string;
}

export interface CreateCheckoutSessionDto {
  stripePriceId: string;
  receiverEmail?: string;
}

export interface CheckoutUrlDto {
  url: string;
}

export interface TermDto {
  id: string;
  version: number;
  content: string;
  createdAt: string;
}

export interface TermsAcceptanceCheckDto {
  term: TermDto;
  accepted: boolean;
}

export interface TermsDto {
  terms: TermDto[];
}

export interface PrivacyPolicyDto {
  id: string;
  version: number;
  content: string;
  createdAt: string;
}

export interface PolicyAcceptanceCheckDto {
  privacyPolicy: PrivacyPolicyDto;
  accepted: boolean;
}

export interface PrivacyPoliciesDto {
  privacyPolicies: PrivacyPolicyDto[];
}

export interface WhatsappMessageDto {
  /** Array of phone numbers */
  receivers: any[] | null;
  body: string;
}

export interface WorkspaceTeamDto {
  id: string;
  name: string;
  workspaceId: string;
  ownerId: string;
  notes: object | null;
  streetAddress: object | null;
  city: object | null;
  state: object | null;
  zipCode: object | null;
  country: object | null;
  locationName: object | null;
  createdAt: string;
  updatedAt: string | null;
}

export interface WorkspaceTeamsDto {
  workspaceTeams: WorkspaceTeamDto[];
}

export interface ScheduleEventDto {
  id: string;
  tourId: string;
  eventType: string;
  eventTypeName: string;
  countryCode: string;
  state: string;
  city: string;
  nextDay: boolean;
  eventDetails: EventDetails | null;
  eventProvider: EventProviderDto | null;
  startDate: string | null;
  endDate: string | null;
  additionalInformation: EventAdditionalInformation | null;
  notes: string | null;
  streetAddress: string | null;
  zipCode: string | null;
  timezoneId: string | null;
}

export interface ScheduleTourDto {
  tourName: string;
  tourId: string;
  artistName: string;
  events: ScheduleEventDto[];
}

export interface ScheduleDayDto {
  date: string;
  tours: ScheduleTourDto[];
}

export interface UserAvailabilitiesDto {
  userId: string;
  userFirstName: string;
  userLastName: string;
  userEmail: string;
  userAvatarKey: string;
  teamMemberId: string;
  teamPosition: string;
  schedule: ScheduleDayDto[];
}

export interface UsersAvailabilitiesDto {
  usersAvailabilities: UserAvailabilitiesDto[];
}

export interface CreateMemoEstimateDto {
  /** @format date-time */
  startDate?: string | null;
  /** @format date-time */
  endDate?: string | null;
  workspaceTeamMemberId: string;
  tourId: string;
  jobNumber: string;
  position: string;
}

export interface MemoUser {
  userId: string;
  firstName?: string;
  lastName?: string;
  phoneNumber?: string;
  birthDate?: string | null;
  email: string;
}

export interface DayEstimate {
  day: string;
  date: string;
  dailyWage?: number | null;
  perDiem?: number | null;
  retainer?: number | null;
  week: number;
}

export interface WeekEstimate {
  week: number;
  dailyWage?: number | null;
  perDiem?: number | null;
  retainer?: number | null;
  total?: number | null;
  days: DayEstimate[];
}

export interface MemoEstimates {
  weeks: WeekEstimate[];
}

export interface MemoEstimateDto {
  id: string;
  workspaceTeamMemberId: string;
  tourId: string;
  tourName: string;
  jobNumber: string;
  position: string;
  user: MemoUser;
  startDate: string;
  endDate: string;
  initialEstimate: MemoEstimates;
  finalEstimate: MemoEstimates | null;
}

export interface WorkspaceTeamTourDto {
  tourId: string;
  tourName: string;
}

export interface WorkspaceTeamToursDto {
  tours: WorkspaceTeamTourDto[];
}

export interface CreateWorkspaceTeamDto {
  name: string;
  workspaceId: string;
  notes?: string | null;
  streetAddress?: string | null;
  city?: string | null;
  state?: string | null;
  zipCode?: string | null;
  country?: string | null;
  locationName?: string | null;
}

export interface UpdateWorkspaceTeamDto {
  name?: string;
  notes?: string | null;
  streetAddress?: string | null;
  city?: string | null;
  state?: string | null;
  zipCode?: string | null;
  country?: string | null;
  locationName?: string | null;
}

export interface CreateWorkspaceTeamInvitationDto {
  workspaceMemberIds: string[];
}

export interface UserAddressDto {
  streetAddress: string | null;
  city: string | null;
  countryCode: string | null;
  state: string | null;
  zipCode: string | null;
}

export interface WorkspaceTeamMemberUserDto {
  id: string;
  email: string;
  firstName: string | null;
  lastName: string | null;
  avatarKey: string | null;
  homeAirport: string | null;
  phoneNumber: string | null;
  addresses: UserAddressDto[] | null;
}

export interface WorkspaceTeamMemberDto {
  id: string;
  workspaceTeamId: string;
  workspaceMemberId: string;
  position: string | null;
  notes: string | null;
  currentlyOnProject: boolean;
  createdAt: string;
  updatedAt: string | null;
  user: WorkspaceTeamMemberUserDto;
}

export interface WorkspaceTeamMembersDto {
  workspaceTeamMembers: WorkspaceTeamMemberDto[];
}

export interface UpdateWorkspaceTeamMemberDto {
  position?: string;
  notes?: string;
}

export interface CreateWageDto {
  tourId: string;
  wageDaily: number;
  hourRate: number;
  perDiem: number;
}

export interface WageDto {
  id: string;
  workspaceTeamMemberId: string;
  tourId: string;
  wageDaily: number;
  hourRate?: number | null;
  perDiem: number;
  createdAt: string;
  updatedAt: string | null;
}

export interface UpdateWageDto {
  wageDaily?: number;
  hourRate?: number;
  perDiem?: number;
}

export interface WagesDto {
  workspaceTeamMemberWages: WageDto[];
}

export interface UpdateMemoEstimateDto {
  jobNumber?: string;
  position?: string;
  finalEstimate?: MemoEstimates;
}

export interface MemoEstimatesDto {
  estimates: MemoEstimateDto[];
}

export interface ReportUser {
  userId: string;
  firstName?: string;
  lastName?: string;
  email: string;
  teamPosition?: string;
}

export interface SummaryReport {
  numberOfProjects: number;
  numberOfDaysWorked: number;
  numberOfTravelDays: number;
  numberOfShowDays: number;
  numberOfRehearsalDays: number;
  numberOfWorkingDays: number;
  TotalDayPay: number;
  TotalPerDiemPay: number;
  TotalPay: number;
}

export interface MemberSummaryReportDto {
  id: string;
  workspaceTeamMemberId: string;
  user: ReportUser;
  startDate: string;
  endDate: string;
  content: SummaryReport;
}

export interface SummaryReportsDto {
  summaryReports: MemberSummaryReportDto[];
}

export interface CreateMemberSummaryReportDto {
  /** @format date-time */
  startDate: string;
  /** @format date-time */
  endDate: string;
  workspaceTeamMemberIds: string[];
}

export interface TeamInvitationDto {
  id: string;
  workspaceMemberId: string;
  workspaceTeamId: string;
  teamOwnerId: string;
  teamOwnerFirstName?: string | null;
  teamOwnerLastName?: string | null;
  workspaceTeamName: string;
  workspaceName: string;
  createdAt: string;
  updatedAt: string | null;
}

export interface TeamInvitationsDto {
  teamInvitations: TeamInvitationDto[];
}

export interface TourInvitationDto {
  id: string;
  email: string;
  tourId: string;
  tourName: string;
  roleId: string;
  createdAt: string;
  updatedAt: string | null;
}

export interface InvitationsDto {
  invitations: TeamInvitationsDto;
  tourInvitations: TourInvitationDto[];
}

export interface CombinedCalendarEventsDto {
  /**
   * Events grouped by tourId
   * @example {"uuid":[{"id":"event1"},{"id":"event2"}]}
   */
  events: Record<string, any[]>;
}

export interface UpdateVenueFormSubmissionDto {
  questions: VenueFormQuestion[];
}

export interface TravelTrackerUserDto {
  /** User first name */
  firstName?: string | null;
  /** User last name */
  lastName?: string | null;
  /** User email */
  email: string;
  /** User avatar URL */
  avatar: object | null;
}

export interface TravelTrackerItemDto {
  /** User information */
  user: TravelTrackerUserDto;
  /** Events grouped by days */
  days: object;
}

export interface TravelTrackerResponseDto {
  /** Travel tracker items */
  items: TravelTrackerItemDto[];
}

export interface CreateTourFolderDto {
  tourId: string;
  tourDayId?: string;
  parentFolderId?: string;
  name: string;
}

export interface UpdateTourFolderDto {
  name?: string;
  parentFolderId?: string | null;
}

export interface CreatePersonalNoteDto {
  title: string;
  description?: string;
  status?: "pending" | "in_progress" | "completed";
  priority?: "low" | "medium" | "high";
  /** @format date-time */
  dueDate?: string;
}

export interface PersonalNoteDto {
  id: string;
  userId: string;
  title: string;
  description: string | null;
  status: "pending" | "in_progress" | "completed";
  priority: "low" | "medium" | "high";
  dueDate: string | null;
  createdAt: string;
  completedAt: string | null;
  archivedAt: string | null;
  updatedAt: string | null;
}

export interface PersonalNotesDto {
  personalNotes: PersonalNoteDto[];
}

export interface UpdatePersonalNoteDto {
  title?: string;
  description?: string;
  status?: "pending" | "in_progress" | "completed";
  priority?: "low" | "medium" | "high";
  /** @format date-time */
  dueDate?: string;
}

export interface ScratchpadParagraphDataDto {
  text: string;
}

export interface ScratchpadParagraphBlockDto {
  id: string;
  type: "paragraph" | "checklist" | "image" | "file";
  data: ScratchpadParagraphDataDto;
}

export interface ScratchpadChecklistItemDto {
  id: string;
  text: string;
  checked: boolean;
}

export interface ScratchpadChecklistDataDto {
  items: ScratchpadChecklistItemDto[];
}

export interface ScratchpadChecklistBlockDto {
  id: string;
  type: "paragraph" | "checklist" | "image" | "file";
  data: ScratchpadChecklistDataDto;
}

export interface ScratchpadImageDataDto {
  assetId: string;
  url?: object;
  caption?: string;
  width?: number;
  height?: number;
}

export interface ScratchpadImageBlockDto {
  id: string;
  type: "paragraph" | "checklist" | "image" | "file";
  data: ScratchpadImageDataDto;
}

export interface ScratchpadFileDataDto {
  assetId: string;
  url?: object;
  fileName: string;
  mimeType: string;
  size: number;
}

export interface ScratchpadFileBlockDto {
  id: string;
  type: "paragraph" | "checklist" | "image" | "file";
  data: ScratchpadFileDataDto;
}

export interface CreateScratchpadDto {
  title: string;
  /** @minItems 1 */
  blocks: (
    | ScratchpadParagraphBlockDto
    | ScratchpadChecklistBlockDto
    | ScratchpadImageBlockDto
    | ScratchpadFileBlockDto
  )[];
  /** @format date-time */
  pinnedAt?: string | null;
}

export interface ScratchpadDto {
  id: string;
  userId: string;
  title: string;
  /** @minItems 1 */
  blocks: (
    | ScratchpadParagraphBlockDto
    | ScratchpadChecklistBlockDto
    | ScratchpadImageBlockDto
    | ScratchpadFileBlockDto
  )[];
  pinnedAt: string | null;
  createdAt: string;
  updatedAt: string | null;
}

export interface ScratchpadsDto {
  scratchpads: ScratchpadDto[];
}

export interface UpdateScratchpadDto {
  title: string;
  /** @minItems 1 */
  blocks: (
    | ScratchpadParagraphBlockDto
    | ScratchpadChecklistBlockDto
    | ScratchpadImageBlockDto
    | ScratchpadFileBlockDto
  )[];
  /** @format date-time */
  pinnedAt?: string | null;
}

export interface UploadScratchpadAssetDto {
  blockId: string;
  scratchpadId?: string;
}

export interface ScratchpadAssetDto {
  assetId: string;
  fileName: string;
  mimeType: string;
  size: number;
  url?: string;
}

export interface CreateAchievementDto {
  title: string;
  description?: string | null;
}

export interface AchievementDto {
  id: string;
  userId: string;
  title: string;
  description: string | null;
  createdAt: string;
  updatedAt: string | null;
}

export interface AchievementsDto {
  achievements: AchievementDto[];
}

export interface UpdateAchievementDto {
  title?: string;
  description?: string | null;
}

export interface CreateFavoriteContentDto {
  title: string;
  description?: string | null;
}

export interface FavoriteContentDto {
  id: string;
  userId: string;
  title: string;
  description: string | null;
  createdAt: string;
  updatedAt: string | null;
}

export interface FavoriteContentsDto {
  favoriteContents: FavoriteContentDto[];
}

export interface UpdateFavoriteContentDto {
  title?: string;
  description?: string | null;
}

export interface DirectoryListItemDto {
  id: string;
  firstName: string | null;
  lastName: string | null;
  avatarUrl: string | null;
  jobTitle: string | null;
  socialMediaLinks: SocialMediaLinks | null;
}

export interface DirectoryListDto {
  results: DirectoryListItemDto[];
  nextCursor: string | null;
}

export interface DirectoryTourRelatedListItemDto {
  id: string;
  firstName: string | null;
  lastName: string | null;
  email: string | null;
  avatarUrl: string | null;
  jobTitle: string | null;
  socialMediaLinks: SocialMediaLinks | null;
}

export interface DirectoryTourRelatedListDto {
  results: DirectoryTourRelatedListItemDto[];
  nextOffset: number | null;
}

export interface DirectoryAchievementDto {
  id: string;
  title: string;
  description: string | null;
}

export interface DirectoryFavoriteContentDto {
  id: string;
  title: string;
  description: string | null;
}

export interface DirectoryBioDataDto {
  email: string;
  phoneNumber: string | null;
  addresses: AddressDto[];
  emergencyContacts: EmergencyContactDto[];
  travellingDetails: TravellingDetailDto | null;
}

export interface DirectoryProfileDto {
  id: string;
  firstName: string | null;
  lastName: string | null;
  avatarUrl: string | null;
  jobTitle: string | null;
  aboutMe: string | null;
  socialMediaLinks: SocialMediaLinks | null;
  achievements: DirectoryAchievementDto[];
  favoriteContents: DirectoryFavoriteContentDto[];
  canViewBioData: boolean;
  bioData?: DirectoryBioDataDto;
}

export interface FlightExtractionResponseDto {
  /**
   * Whether the extraction was successful
   * @example true
   */
  success: boolean;
  /**
   * The method used for extraction
   * @example "pdf"
   */
  method: "pdf" | "text";
  /**
   * Extracted text from the document (for debugging)
   * @example "Flight LX8295 from Bristol to Zurich..."
   */
  extractedText?: string;
  /** Array of extracted flight events */
  flightInfo: CreateEventV1Dto[];
  /**
   * Processing time in milliseconds
   * @example 1500
   */
  processingTime?: number;
  /**
   * Error message if extraction failed
   * @example "Failed to parse PDF"
   */
  error?: string;
}

export interface TourScheduleImportedDayDto {
  date: string;
  tagName: string;
  location?: object | null;
  skippedReason?: object | null;
  venueSaved?: boolean;
  venueSaveError?: object | null;
}

export interface TourScheduleSkippedDayDto {
  date: string;
  reason: string;
}

export interface TourScheduleImportResponseDto {
  savedDays: TourScheduleImportedDayDto[];
  skippedDays: TourScheduleSkippedDayDto[];
  venueSaveFailures: TourScheduleSkippedDayDto[];
}

export interface ResourceDto {
  id: string;
  categoryId: string;
  title: string;
  url: string;
  imageKey: string | null;
  imageUrl: string | null;
  orderIndex: number;
  isActive: boolean;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string | null;
}

export interface ResourceCategoryDto {
  id: string;
  title: string;
  orderIndex: number;
  isActive: boolean;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string | null;
  items: ResourceDto[];
}

export interface ResourcesListDto {
  categories: ResourceCategoryDto[];
}

export interface CreateResourceCategoryDto {
  title: string;
  /** @default 0 */
  orderIndex?: number;
  /** @default true */
  isActive?: boolean;
}

export interface UpdateResourceCategoryDto {
  title?: string;
  /** @default 0 */
  orderIndex?: number;
  /** @default true */
  isActive?: boolean;
}

export interface CreateResourceDto {
  categoryId: string;
  title: string;
  url: string;
  imageKey?: string | null;
  /** @default 0 */
  orderIndex?: number;
  /** @default true */
  isActive?: boolean;
}

export interface UpdateResourceDto {
  categoryId?: string;
  title?: string;
  url?: string;
  imageKey?: string | null;
  /** @default 0 */
  orderIndex?: number;
  /** @default true */
  isActive?: boolean;
}

export interface CommunityItemDto {
  id: string;
  categoryId: string;
  title: string;
  url: string;
  imageKey: string | null;
  imageUrl: string | null;
  orderIndex: number;
  isActive: boolean;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string | null;
}

export interface CommunityCategoryDto {
  id: string;
  title: string;
  orderIndex: number;
  isActive: boolean;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string | null;
  items: CommunityItemDto[];
}

export interface CommunitiesListDto {
  categories: CommunityCategoryDto[];
}

export interface CreateCommunityCategoryDto {
  title: string;
  /** @default 0 */
  orderIndex?: number;
  /** @default true */
  isActive?: boolean;
}

export interface UpdateCommunityCategoryDto {
  title?: string;
  /** @default 0 */
  orderIndex?: number;
  /** @default true */
  isActive?: boolean;
}

export interface CreateCommunityItemDto {
  categoryId: string;
  title: string;
  url: string;
  imageKey?: string | null;
  /** @default 0 */
  orderIndex?: number;
  /** @default true */
  isActive?: boolean;
}

export interface UpdateCommunityItemDto {
  categoryId?: string;
  title?: string;
  url?: string;
  imageKey?: string | null;
  /** @default 0 */
  orderIndex?: number;
  /** @default true */
  isActive?: boolean;
}

import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, HeadersDefaults, ResponseType } from "axios";
import axios from "axios";

export type QueryParamsType = Record<string | number, any>;

export interface FullRequestParams extends Omit<AxiosRequestConfig, "data" | "params" | "url" | "responseType"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType;
  /** request body */
  body?: unknown;
}

export type RequestParams = Omit<FullRequestParams, "body" | "method" | "query" | "path">;

export interface ApiConfig<SecurityDataType = unknown> extends Omit<AxiosRequestConfig, "data" | "cancelToken"> {
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void;
  secure?: boolean;
  format?: ResponseType;
}

export enum ContentType {
  Json = "application/json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance;
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private secure?: boolean;
  private format?: ResponseType;

  constructor({ securityWorker, secure, format, ...axiosConfig }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axios.create({ ...axiosConfig, baseURL: axiosConfig.baseURL || "" });
    this.secure = secure;
    this.format = format;
    this.securityWorker = securityWorker;
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected mergeRequestParams(params1: AxiosRequestConfig, params2?: AxiosRequestConfig): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method);

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method && this.instance.defaults.headers[method.toLowerCase() as keyof HeadersDefaults]) || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === "object" && formItem !== null) {
      return JSON.stringify(formItem);
    } else {
      return `${formItem}`;
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key];
      const propertyContent: any[] = property instanceof Array ? property : [property];

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File;
        formData.append(key, isFileType ? formItem : this.stringifyFormItem(formItem));
      }

      return formData;
    }, new FormData());
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<AxiosResponse<T>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const responseFormat = format || this.format || undefined;

    if (type === ContentType.FormData && body && body !== null && typeof body === "object") {
      body = this.createFormData(body as Record<string, unknown>);
    }

    if (type === ContentType.Text && body && body !== null && typeof body !== "string") {
      body = JSON.stringify(body);
    }

    return this.instance.request({
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type && type !== ContentType.FormData ? { "Content-Type": type } : {}),
      },
      params: query,
      responseType: responseFormat,
      data: body,
      url: path,
    });
  };
}

/**
 * @title GoForShow API
 * @version 1.0
 * @contact
 *
 * GoForShow API description
 */
export class BaseApi<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
  healthcheck = {
    /**
     * No description
     *
     * @name AppControllerGetHello
     * @request GET:/healthcheck
     */
    appControllerGetHello: (params: RequestParams = {}) =>
      this.request<HealthcheckEntity, any>({
        path: `/healthcheck`,
        method: "GET",
        format: "json",
        ...params,
      }),
  };
  addresses = {
    /**
     * No description
     *
     * @name AddressesControllerUpdate
     * @request PATCH:/addresses/{id}
     */
    addressesControllerUpdate: (id: string, data: UpdateAddressDto, params: RequestParams = {}) =>
      this.request<AddressDto, any>({
        path: `/addresses/${id}`,
        method: "PATCH",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  artistAddresses = {
    /**
     * No description
     *
     * @name ArtistAddressesControllerCreate
     * @request POST:/artist-addresses
     */
    artistAddressesControllerCreate: (data: CreateArtistAddressDto, params: RequestParams = {}) =>
      this.request<ArtistAddressDto, any>({
        path: `/artist-addresses`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name ArtistAddressesControllerFindMany
     * @request POST:/artist-addresses/search
     */
    artistAddressesControllerFindMany: (data: ArtistAddressesQueryDto, params: RequestParams = {}) =>
      this.request<ArtistAddressesDto, any>({
        path: `/artist-addresses/search`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name ArtistAddressesControllerRemove
     * @request DELETE:/artist-addresses/{id}
     */
    artistAddressesControllerRemove: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/artist-addresses/${id}`,
        method: "DELETE",
        ...params,
      }),
  };
  users = {
    /**
     * No description
     *
     * @name UsersControllerCreate
     * @request POST:/users
     */
    usersControllerCreate: (data: CreateUserDto, params: RequestParams = {}) =>
      this.request<UserIdDto, any>({
        path: `/users`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name UsersControllerGetCurrentUser
     * @request GET:/users/current-user
     */
    usersControllerGetCurrentUser: (params: RequestParams = {}) =>
      this.request<UserDto, any>({
        path: `/users/current-user`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name UsersControllerUpdateUser
     * @request PATCH:/users/current-user
     */
    usersControllerUpdateUser: (data: UpdateUserDto, params: RequestParams = {}) =>
      this.request<UserIdDto, any>({
        path: `/users/current-user`,
        method: "PATCH",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name UsersControllerUpdatePassword
     * @request PATCH:/users/update-password
     */
    usersControllerUpdatePassword: (data: UpdatePasswordDto, params: RequestParams = {}) =>
      this.request<AuthTokensResponseDto, any>({
        path: `/users/update-password`,
        method: "PATCH",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name UsersControllerResetPassword
     * @request PATCH:/users/reset-password
     */
    usersControllerResetPassword: (
      query: {
        email: string;
        token: string;
      },
      data: PublicResetPasswordDto,
      params: RequestParams = {},
    ) =>
      this.request<UserIdDto, any>({
        path: `/users/reset-password`,
        method: "PATCH",
        query: query,
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name UsersControllerUploadFile
     * @request POST:/users/upload_avatar
     */
    usersControllerUploadFile: (params: RequestParams = {}) =>
      this.request<UserAvatarDto, any>({
        path: `/users/upload_avatar`,
        method: "POST",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name UserStatusControllerUpdate
     * @request PATCH:/users/status/{id}
     */
    userStatusControllerUpdate: (id: string, data: UpdateUserStatusDto, params: RequestParams = {}) =>
      this.request<UpdateUserStatusResponseDto, any>({
        path: `/users/status/${id}`,
        method: "PATCH",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name UserPersonalDetailsControllerFindCurrentUser
     * @request GET:/users/current-user/personal-details
     */
    userPersonalDetailsControllerFindCurrentUser: (params: RequestParams = {}) =>
      this.request<PersonalDetailDto, any>({
        path: `/users/current-user/personal-details`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name UserPersonalDetailsControllerFindOne
     * @request GET:/users/{userId}/personal-details
     */
    userPersonalDetailsControllerFindOne: (userId: string, params: RequestParams = {}) =>
      this.request<PersonalDetailDto, any>({
        path: `/users/${userId}/personal-details`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name UserPersonalDetailsControllerUpdate
     * @request PATCH:/users/personal-details/{id}
     */
    userPersonalDetailsControllerUpdate: (id: string, data: UpdatePersonalDetailDto, params: RequestParams = {}) =>
      this.request<PersonalDetailDto, any>({
        path: `/users/personal-details/${id}`,
        method: "PATCH",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name UserPersonalDetailsControllerCreate
     * @request POST:/users/personal-details/create-address
     */
    userPersonalDetailsControllerCreate: (data: CreateAddressDto, params: RequestParams = {}) =>
      this.request<AddressDto, any>({
        path: `/users/personal-details/create-address`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name UserPersonalDetailsControllerUploadFile
     * @request POST:/users/personal-details/upload-personal-documents
     */
    userPersonalDetailsControllerUploadFile: (data: PersonalDocumentDto, params: RequestParams = {}) =>
      this.request<UploadedFileKeyDto, any>({
        path: `/users/personal-details/upload-personal-documents`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name UserPersonalDetailsControllerDeleteFile
     * @request DELETE:/users/personal-details/delete-personal-document
     */
    userPersonalDetailsControllerDeleteFile: (data: DeletePersonalDocumentDto, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/users/personal-details/delete-personal-document`,
        method: "DELETE",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @name UserPersonalDetailsControllerCreateCitizenship
     * @request POST:/users/personal-details/citizenships
     */
    userPersonalDetailsControllerCreateCitizenship: (data: CreateUserCitizenshipDto, params: RequestParams = {}) =>
      this.request<UploadedFileKeyDto, any>({
        path: `/users/personal-details/citizenships`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name UserPersonalDetailsControllerRemoveCitizenship
     * @request DELETE:/users/personal-details/citizenships
     */
    userPersonalDetailsControllerRemoveCitizenship: (data: CreateUserCitizenshipDto, params: RequestParams = {}) =>
      this.request<UploadedFileKeyDto, any>({
        path: `/users/personal-details/citizenships`,
        method: "DELETE",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name UserTravellingDetailsControllerFindCurrentUser
     * @request GET:/users/current-user/travelling-details
     */
    userTravellingDetailsControllerFindCurrentUser: (params: RequestParams = {}) =>
      this.request<TravellingDetailDto, any>({
        path: `/users/current-user/travelling-details`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name UserTravellingDetailsControllerFindOne
     * @request GET:/users/{userId}/travelling-details
     */
    userTravellingDetailsControllerFindOne: (userId: string, params: RequestParams = {}) =>
      this.request<TravellingDetailDto, any>({
        path: `/users/${userId}/travelling-details`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name UserTravellingDetailsControllerUpdate
     * @request PATCH:/users/travelling-details/{id}
     */
    userTravellingDetailsControllerUpdate: (id: string, data: UpdateTravellingDetailDto, params: RequestParams = {}) =>
      this.request<TravellingDetailDto, any>({
        path: `/users/travelling-details/${id}`,
        method: "PATCH",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name UserTravellingDetailsControllerUploadFile
     * @request POST:/users/travelling-details/upload-passport
     */
    userTravellingDetailsControllerUploadFile: (data: AddPassportDto, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/users/travelling-details/upload-passport`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @name UserTravellingDetailsControllerDeletePassport
     * @request DELETE:/users/travelling-details/delete-passport
     */
    userTravellingDetailsControllerDeletePassport: (data: DeletePassportDto, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/users/travelling-details/delete-passport`,
        method: "DELETE",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @name UserEmergencyContactsControllerCreate
     * @request POST:/users/emergency-contacts
     */
    userEmergencyContactsControllerCreate: (data: CreateEmergencyContactDto, params: RequestParams = {}) =>
      this.request<EmergencyContactDto, any>({
        path: `/users/emergency-contacts`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name UserEmergencyContactsControllerFindManyCurrentUser
     * @request GET:/users/current-user/emergency-contacts
     */
    userEmergencyContactsControllerFindManyCurrentUser: (params: RequestParams = {}) =>
      this.request<EmergencyContactsDto, any>({
        path: `/users/current-user/emergency-contacts`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name UserEmergencyContactsControllerFindMany
     * @request GET:/users/{userId}/emergency-contacts
     */
    userEmergencyContactsControllerFindMany: (userId: string, params: RequestParams = {}) =>
      this.request<EmergencyContactsDto, any>({
        path: `/users/${userId}/emergency-contacts`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name UserEmergencyContactsControllerUpdate
     * @request PATCH:/users/emergency-contacts/{id}
     */
    userEmergencyContactsControllerUpdate: (id: string, data: UpdateEmergencyContactDto, params: RequestParams = {}) =>
      this.request<EmergencyContactDto, any>({
        path: `/users/emergency-contacts/${id}`,
        method: "PATCH",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name UserEmergencyContactsControllerRemove
     * @request DELETE:/users/emergency-contacts/{id}
     */
    userEmergencyContactsControllerRemove: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/users/emergency-contacts/${id}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * No description
     *
     * @name UserAchievementsControllerCreate
     * @request POST:/users/achievements
     */
    userAchievementsControllerCreate: (data: CreateAchievementDto, params: RequestParams = {}) =>
      this.request<AchievementDto, any>({
        path: `/users/achievements`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name UserAchievementsControllerFindManyCurrentUser
     * @request GET:/users/current-user/achievements
     */
    userAchievementsControllerFindManyCurrentUser: (params: RequestParams = {}) =>
      this.request<AchievementsDto, any>({
        path: `/users/current-user/achievements`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name UserAchievementsControllerFindMany
     * @request GET:/users/{userId}/achievements
     */
    userAchievementsControllerFindMany: (userId: string, params: RequestParams = {}) =>
      this.request<AchievementsDto, any>({
        path: `/users/${userId}/achievements`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name UserAchievementsControllerUpdate
     * @request PATCH:/users/achievements/{id}
     */
    userAchievementsControllerUpdate: (id: string, data: UpdateAchievementDto, params: RequestParams = {}) =>
      this.request<AchievementDto, any>({
        path: `/users/achievements/${id}`,
        method: "PATCH",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name UserAchievementsControllerRemove
     * @request DELETE:/users/achievements/{id}
     */
    userAchievementsControllerRemove: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/users/achievements/${id}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * No description
     *
     * @name UserFavoriteContentsControllerCreate
     * @request POST:/users/favorite-contents
     */
    userFavoriteContentsControllerCreate: (data: CreateFavoriteContentDto, params: RequestParams = {}) =>
      this.request<FavoriteContentDto, any>({
        path: `/users/favorite-contents`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name UserFavoriteContentsControllerFindManyCurrentUser
     * @request GET:/users/current-user/favorite-contents
     */
    userFavoriteContentsControllerFindManyCurrentUser: (params: RequestParams = {}) =>
      this.request<FavoriteContentsDto, any>({
        path: `/users/current-user/favorite-contents`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name UserFavoriteContentsControllerFindMany
     * @request GET:/users/{userId}/favorite-contents
     */
    userFavoriteContentsControllerFindMany: (userId: string, params: RequestParams = {}) =>
      this.request<FavoriteContentsDto, any>({
        path: `/users/${userId}/favorite-contents`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name UserFavoriteContentsControllerUpdate
     * @request PATCH:/users/favorite-contents/{id}
     */
    userFavoriteContentsControllerUpdate: (id: string, data: UpdateFavoriteContentDto, params: RequestParams = {}) =>
      this.request<FavoriteContentDto, any>({
        path: `/users/favorite-contents/${id}`,
        method: "PATCH",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name UserFavoriteContentsControllerRemove
     * @request DELETE:/users/favorite-contents/{id}
     */
    userFavoriteContentsControllerRemove: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/users/favorite-contents/${id}`,
        method: "DELETE",
        ...params,
      }),
  };
  auth = {
    /**
     * No description
     *
     * @name AuthControllerLogin
     * @request POST:/auth/login
     */
    authControllerLogin: (data: AuthLoginDto, params: RequestParams = {}) =>
      this.request<AuthTokensResponseDto, any>({
        path: `/auth/login`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name AuthControllerRegister
     * @request POST:/auth/register
     */
    authControllerRegister: (data: AuthRegisterDto, params: RequestParams = {}) =>
      this.request<RegisteredUserResponseDto, any>({
        path: `/auth/register`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name AuthControllerRefresh
     * @request POST:/auth/refresh
     */
    authControllerRefresh: (data: RefreshTokenDto, params: RequestParams = {}) =>
      this.request<AuthTokensResponseDto, any>({
        path: `/auth/refresh`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name AuthControllerLogout
     * @request POST:/auth/logout
     */
    authControllerLogout: (params: RequestParams = {}) =>
      this.request<boolean, any>({
        path: `/auth/logout`,
        method: "POST",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name AuthControllerRequestResetPassword
     * @request POST:/auth/request-reset-password
     */
    authControllerRequestResetPassword: (data: ResetPasswordDto, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/auth/request-reset-password`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @name AuthControllerDeleteAccount
     * @request DELETE:/auth/delete-account
     */
    authControllerDeleteAccount: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/auth/delete-account`,
        method: "DELETE",
        ...params,
      }),
  };
  workspaces = {
    /**
     * No description
     *
     * @name WorkspacesControllerFindAll
     * @request GET:/workspaces
     */
    workspacesControllerFindAll: (params: RequestParams = {}) =>
      this.request<WorkspacesDto, any>({
        path: `/workspaces`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name WorkspacesControllerFindOne
     * @request GET:/workspaces/{id}
     */
    workspacesControllerFindOne: (id: string, params: RequestParams = {}) =>
      this.request<WorkspaceDto, any>({
        path: `/workspaces/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name WorkspacesControllerUpdate
     * @request PATCH:/workspaces/{id}
     */
    workspacesControllerUpdate: (id: string, data: UpdateWorkspaceDto, params: RequestParams = {}) =>
      this.request<WorkspaceDto, any>({
        path: `/workspaces/${id}`,
        method: "PATCH",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name WorkspacesControllerFindAllArtists
     * @request GET:/workspaces/{id}/artists
     */
    workspacesControllerFindAllArtists: (id: string, params: RequestParams = {}) =>
      this.request<ArtistsDto, any>({
        path: `/workspaces/${id}/artists`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name WorkspacesControllerFindMembers
     * @request GET:/workspaces/{id}/members
     */
    workspacesControllerFindMembers: (id: string, params: RequestParams = {}) =>
      this.request<WorkspaceMembersDto, any>({
        path: `/workspaces/${id}/members`,
        method: "GET",
        format: "json",
        ...params,
      }),
  };
  artists = {
    /**
     * No description
     *
     * @name ArtistsControllerFindAll
     * @request GET:/artists
     */
    artistsControllerFindAll: (
      query?: {
        artistId?: string | null;
        archived?: boolean | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<ArtistsDto, any>({
        path: `/artists`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name ArtistsControllerCreate
     * @request POST:/artists
     */
    artistsControllerCreate: (data: CreateArtistDto, params: RequestParams = {}) =>
      this.request<ArtistDto, any>({
        path: `/artists`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name ArtistsControllerFindOne
     * @request GET:/artists/{id}
     */
    artistsControllerFindOne: (id: string, params: RequestParams = {}) =>
      this.request<ArtistDto, any>({
        path: `/artists/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name ArtistsControllerUpdate
     * @request PATCH:/artists/{id}
     */
    artistsControllerUpdate: (id: string, data: UpdateArtistDto, params: RequestParams = {}) =>
      this.request<ArtistDto, any>({
        path: `/artists/${id}`,
        method: "PATCH",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name ArtistsControllerRemove
     * @request DELETE:/artists/{id}
     */
    artistsControllerRemove: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/artists/${id}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * No description
     *
     * @name ArtistsControllerUploadFile
     * @request POST:/artists/{id}/upload-file
     */
    artistsControllerUploadFile: (id: string, data: UploadArtistFileDto, params: RequestParams = {}) =>
      this.request<UploadedFileKeyDto, any>({
        path: `/artists/${id}/upload-file`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name ArtistsControllerDeleteFile
     * @request DELETE:/artists/{id}/delete-file
     */
    artistsControllerDeleteFile: (id: string, data: DeleteArtistFileDto, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/artists/${id}/delete-file`,
        method: "DELETE",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @name ArtistsControllerArchive
     * @request PATCH:/artists/{id}/archive
     */
    artistsControllerArchive: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/artists/${id}/archive`,
        method: "PATCH",
        ...params,
      }),

    /**
     * No description
     *
     * @name ArtistsControllerUnarchive
     * @request PATCH:/artists/{id}/unarchive
     */
    artistsControllerUnarchive: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/artists/${id}/unarchive`,
        method: "PATCH",
        ...params,
      }),

    /**
     * No description
     *
     * @name ArtistsControllerCreateEventTemplateCategory
     * @request POST:/artists/{id}/event-template-categories
     */
    artistsControllerCreateEventTemplateCategory: (
      id: string,
      data: CreateEventTemplateCategoryDto,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/artists/${id}/event-template-categories`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @name ArtistsControllerFindEventTemplateCategories
     * @request GET:/artists/{id}/event-template-categories
     */
    artistsControllerFindEventTemplateCategories: (id: string, params: RequestParams = {}) =>
      this.request<EventTemplateCategoriesDto, any>({
        path: `/artists/${id}/event-template-categories`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name ArtistsControllerUpdateEventTemplateCategory
     * @request PATCH:/artists/{id}/event-template-categories/{categoryId}
     */
    artistsControllerUpdateEventTemplateCategory: (
      categoryId: string,
      id: string,
      data: UpdateEventTemplateCategoryDto,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/artists/${id}/event-template-categories/${categoryId}`,
        method: "PATCH",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @name ArtistsControllerDeleteEventTemplateCategory
     * @request DELETE:/artists/{id}/event-template-categories/{categoryId}
     */
    artistsControllerDeleteEventTemplateCategory: (categoryId: string, id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/artists/${id}/event-template-categories/${categoryId}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * No description
     *
     * @name ArtistsControllerCreateEventTemplate
     * @request POST:/artists/{id}/event-templates
     */
    artistsControllerCreateEventTemplate: (id: string, data: CreateEventTemplateDto, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/artists/${id}/event-templates`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @name ArtistsControllerFindEventTemplates
     * @request GET:/artists/{id}/event-templates
     */
    artistsControllerFindEventTemplates: (id: string, params: RequestParams = {}) =>
      this.request<EventTemplatesDto, any>({
        path: `/artists/${id}/event-templates`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name ArtistsControllerUpdateEventTemplate
     * @request PATCH:/artists/{id}/event-templates/{templateId}
     */
    artistsControllerUpdateEventTemplate: (
      templateId: string,
      id: string,
      data: UpdateEventTemplateDto,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/artists/${id}/event-templates/${templateId}`,
        method: "PATCH",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @name ArtistsControllerDeleteEventTemplate
     * @request DELETE:/artists/{id}/event-templates/{templateId}
     */
    artistsControllerDeleteEventTemplate: (templateId: string, id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/artists/${id}/event-templates/${templateId}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * No description
     *
     * @name ArtistsControllerCopyEventTemplateToArtist
     * @request POST:/artists/{id}/event-templates/{templateId}/copy-to-artist
     */
    artistsControllerCopyEventTemplateToArtist: (
      templateId: string,
      id: string,
      data: CopyEventTemplateToArtistDto,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/artists/${id}/event-templates/${templateId}/copy-to-artist`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @name ArtistsControllerCreateVenueForm
     * @request POST:/artists/{id}/venue-forms
     */
    artistsControllerCreateVenueForm: (id: string, data: CreateArtistVenueFormDto, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/artists/${id}/venue-forms`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @name ArtistsControllerFindVenueForms
     * @request GET:/artists/{id}/venue-forms
     */
    artistsControllerFindVenueForms: (id: string, params: RequestParams = {}) =>
      this.request<ArtistVenueFormsDto, any>({
        path: `/artists/${id}/venue-forms`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name ArtistsControllerUpdateVenueForm
     * @request PATCH:/artists/{id}/venue-forms/{formId}
     */
    artistsControllerUpdateVenueForm: (
      formId: string,
      id: string,
      data: UpdateArtistVenueFormDto,
      params: RequestParams = {},
    ) =>
      this.request<ArtistVenueFormDto, any>({
        path: `/artists/${id}/venue-forms/${formId}`,
        method: "PATCH",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name ArtistsControllerDeleteVenueForm
     * @request DELETE:/artists/{id}/venue-forms/{formId}
     */
    artistsControllerDeleteVenueForm: (formId: string, id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/artists/${id}/venue-forms/${formId}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * No description
     *
     * @name ArtistsControllerCopyVenueFormToArtist
     * @request POST:/artists/{id}/venue-forms/{formId}/copy-to-artist
     */
    artistsControllerCopyVenueFormToArtist: (
      formId: string,
      id: string,
      data: CopyVenueFormToArtistDto,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/artists/${id}/venue-forms/${formId}/copy-to-artist`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),
  };
  tours = {
    /**
     * No description
     *
     * @name ToursControllerCreate
     * @request POST:/tours
     */
    toursControllerCreate: (data: CreateTourDto, params: RequestParams = {}) =>
      this.request<TourDto, any>({
        path: `/tours`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name ToursControllerFindAll
     * @request GET:/tours
     */
    toursControllerFindAll: (
      query?: {
        artistId?: string | null;
        archived?: boolean | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<ToursWithArtistDto, any>({
        path: `/tours`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name ToursControllerFindOne
     * @request GET:/tours/{id}
     */
    toursControllerFindOne: (id: string, params: RequestParams = {}) =>
      this.request<TourWithRoleAndArtistDto, any>({
        path: `/tours/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name ToursControllerUpdate
     * @request PATCH:/tours/{id}
     */
    toursControllerUpdate: (id: string, data: UpdateTourDto, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/tours/${id}`,
        method: "PATCH",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @name ToursControllerRemove
     * @request DELETE:/tours/{id}
     */
    toursControllerRemove: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/tours/${id}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * No description
     *
     * @name ToursControllerFindAllPersonnel
     * @request GET:/tours/{id}/personnel
     */
    toursControllerFindAllPersonnel: (id: string, params: RequestParams = {}) =>
      this.request<TourPersonnelArrayDto, any>({
        path: `/tours/${id}/personnel`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name ToursControllerCreatePersonnel
     * @request POST:/tours/{id}/personnel
     */
    toursControllerCreatePersonnel: (id: string, data: CreateTourPersonnelDto, params: RequestParams = {}) =>
      this.request<TourPersonnelDto, any>({
        path: `/tours/${id}/personnel`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name ToursControllerFindPendingInvitations
     * @request GET:/tours/{id}/personnel/invitations
     */
    toursControllerFindPendingInvitations: (id: string, params: RequestParams = {}) =>
      this.request<TourPendingInvitationsDto, any>({
        path: `/tours/${id}/personnel/invitations`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name ToursControllerFindOnePersonnel
     * @request GET:/tours/{id}/personnel/{personnelId}
     */
    toursControllerFindOnePersonnel: (id: string, personnelId: string, params: RequestParams = {}) =>
      this.request<TourPersonnelDto, any>({
        path: `/tours/${id}/personnel/${personnelId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name ToursControllerRemovePersonnel
     * @request DELETE:/tours/{id}/personnel/{personnelId}
     */
    toursControllerRemovePersonnel: (id: string, personnelId: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/tours/${id}/personnel/${personnelId}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * No description
     *
     * @name ToursControllerUpdatePersonnel
     * @request PATCH:/tours/{id}/personnel/{personnelId}
     */
    toursControllerUpdatePersonnel: (
      id: string,
      personnelId: string,
      data: UpdateTourPersonnelDto,
      params: RequestParams = {},
    ) =>
      this.request<TourPersonnelDto, any>({
        path: `/tours/${id}/personnel/${personnelId}`,
        method: "PATCH",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name ToursControllerUploadFile
     * @request POST:/tours/{id}/upload-file
     */
    toursControllerUploadFile: (id: string, data: UploadTourFileDto, params: RequestParams = {}) =>
      this.request<UploadedFileKeyDto, any>({
        path: `/tours/${id}/upload-file`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name ToursControllerDeleteFile
     * @request DELETE:/tours/{id}/delete-file
     */
    toursControllerDeleteFile: (id: string, data: DeleteTourFileDto, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/tours/${id}/delete-file`,
        method: "DELETE",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @name ToursControllerUploadPersonnelCsv
     * @request POST:/tours/{id}/upload-personnel-csv
     */
    toursControllerUploadPersonnelCsv: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/tours/${id}/upload-personnel-csv`,
        method: "POST",
        ...params,
      }),

    /**
     * No description
     *
     * @name ToursControllerArchive
     * @request PATCH:/tours/{id}/archive
     */
    toursControllerArchive: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/tours/${id}/archive`,
        method: "PATCH",
        ...params,
      }),

    /**
     * No description
     *
     * @name ToursControllerUnarchive
     * @request PATCH:/tours/{id}/unarchive
     */
    toursControllerUnarchive: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/tours/${id}/unarchive`,
        method: "PATCH",
        ...params,
      }),

    /**
     * No description
     *
     * @name ToursControllerArchiveForMe
     * @request PATCH:/tours/{id}/archive-for-me
     */
    toursControllerArchiveForMe: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/tours/${id}/archive-for-me`,
        method: "PATCH",
        ...params,
      }),

    /**
     * No description
     *
     * @name ToursControllerUnarchiveForMe
     * @request PATCH:/tours/{id}/unarchive-for-me
     */
    toursControllerUnarchiveForMe: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/tours/${id}/unarchive-for-me`,
        method: "PATCH",
        ...params,
      }),

    /**
     * No description
     *
     * @name ToursControllerModifyShareConsent
     * @request PATCH:/tours/{id}/share-information-consent
     */
    toursControllerModifyShareConsent: (
      id: string,
      data: UpdateShareInformationConsentDto,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/tours/${id}/share-information-consent`,
        method: "PATCH",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @name ToursControllerCreateVenueFormSubmission
     * @request POST:/tours/{id}/venue-form-submissions
     */
    toursControllerCreateVenueFormSubmission: (
      id: string,
      data: CreateVenueFormSubmissionDto,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/tours/${id}/venue-form-submissions`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @name ToursControllerFindVenueFormSubmissions
     * @request GET:/tours/{id}/venue-form-submissions
     */
    toursControllerFindVenueFormSubmissions: (id: string, params: RequestParams = {}) =>
      this.request<VenueFormSubmissionsDto, any>({
        path: `/tours/${id}/venue-form-submissions`,
        method: "GET",
        format: "json",
        ...params,
      }),
  };
  tourPersonnelRoles = {
    /**
     * No description
     *
     * @name TourPersonnelRolesControllerCreate
     * @request POST:/tour-personnel-roles
     */
    tourPersonnelRolesControllerCreate: (data: CreateTourPersonnelRoleDto, params: RequestParams = {}) =>
      this.request<TourPersonnelRoleDto, any>({
        path: `/tour-personnel-roles`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name TourPersonnelRolesControllerFindAll
     * @request GET:/tour-personnel-roles
     */
    tourPersonnelRolesControllerFindAll: (params: RequestParams = {}) =>
      this.request<TourPersonnelRolesDto, any>({
        path: `/tour-personnel-roles`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name TourPersonnelRolesControllerFindOne
     * @request GET:/tour-personnel-roles/{id}
     */
    tourPersonnelRolesControllerFindOne: (id: string, params: RequestParams = {}) =>
      this.request<TourPersonnelRoleDto, any>({
        path: `/tour-personnel-roles/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name TourPersonnelRolesControllerUpdate
     * @request PATCH:/tour-personnel-roles/{id}
     */
    tourPersonnelRolesControllerUpdate: (id: string, data: UpdateTourPersonnelRoleDto, params: RequestParams = {}) =>
      this.request<TourPersonnelRoleDto, any>({
        path: `/tour-personnel-roles/${id}`,
        method: "PATCH",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name TourPersonnelRolesControllerRemove
     * @request DELETE:/tour-personnel-roles/{id}
     */
    tourPersonnelRolesControllerRemove: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/tour-personnel-roles/${id}`,
        method: "DELETE",
        ...params,
      }),
  };
  admin = {
    /**
     * No description
     *
     * @name AdminControllerCreateUser
     * @request POST:/admin/users
     */
    adminControllerCreateUser: (data: CreateUserDto, params: RequestParams = {}) =>
      this.request<UserIdDto, any>({
        path: `/admin/users`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name AdminControllerAllUsers
     * @request GET:/admin/users
     */
    adminControllerAllUsers: (
      query?: {
        /**
         * @min 1
         * @default 1
         */
        page?: number;
        /**
         * @min 1
         * @max 100
         * @default 10
         */
        limit?: number;
        search?: string | null;
        /** @default "createdAt" */
        sortBy?: "name" | "email" | "createdAt";
        /** @default "desc" */
        sortOrder?: "asc" | "desc";
      },
      params: RequestParams = {},
    ) =>
      this.request<AdminUsersListDto, any>({
        path: `/admin/users`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name AdminControllerFindUserDetails
     * @request GET:/admin/users/{id}/details
     */
    adminControllerFindUserDetails: (id: string, params: RequestParams = {}) =>
      this.request<AdminUserDetailsDto, any>({
        path: `/admin/users/${id}/details`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name AdminControllerAllWorkspaces
     * @request GET:/admin/workspaces
     */
    adminControllerAllWorkspaces: (params: RequestParams = {}) =>
      this.request<WorkspacesDto, any>({
        path: `/admin/workspaces`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name AdminControllerCreate
     * @request POST:/admin/workspaces/{userId}
     */
    adminControllerCreate: (userId: string, params: RequestParams = {}) =>
      this.request<boolean, any>({
        path: `/admin/workspaces/${userId}`,
        method: "POST",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name AdminControllerAllTours
     * @request GET:/admin/tours
     */
    adminControllerAllTours: (params: RequestParams = {}) =>
      this.request<ToursDto, any>({
        path: `/admin/tours`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name AdminControllerCreateEventType
     * @request POST:/admin/events/types
     */
    adminControllerCreateEventType: (data: CreateEventTypeV1Dto, params: RequestParams = {}) =>
      this.request<EventTypeV1Dto, any>({
        path: `/admin/events/types`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name AdminControllerAllEventTypes
     * @request GET:/admin/events/types
     */
    adminControllerAllEventTypes: (params: RequestParams = {}) =>
      this.request<EventTypeV1Dto, any>({
        path: `/admin/events/types`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name AdminControllerUpdateEventType
     * @request PATCH:/admin/events/types/{id}
     */
    adminControllerUpdateEventType: (id: string, data: CreateEventTypeV1Dto, params: RequestParams = {}) =>
      this.request<EventTypeV1Dto, any>({
        path: `/admin/events/types/${id}`,
        method: "PATCH",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name AdminControllerAllEvents
     * @request GET:/admin/events
     */
    adminControllerAllEvents: (
      query?: {
        /** @format date-time */
        from?: string | null;
        /** @format date-time */
        to?: string | null;
        typeId?: string | null;
        /** Array of UUIDs */
        artistIds?: any[] | null;
        /** Array of UUIDs */
        groupIds?: any[] | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<EventsV1Dto, any>({
        path: `/admin/events`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name AdminControllerTriggerIndustryFeedSync
     * @request POST:/admin/industry-feed-aggregator/sync
     */
    adminControllerTriggerIndustryFeedSync: (params: RequestParams = {}) =>
      this.request<
        {
          /** @example true */
          accepted?: boolean;
        },
        any
      >({
        path: `/admin/industry-feed-aggregator/sync`,
        method: "POST",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Resources
     * @name ResourcesAdminControllerFindAll
     * @request GET:/admin/resources
     * @secure
     */
    resourcesAdminControllerFindAll: (params: RequestParams = {}) =>
      this.request<ResourcesListDto, any>({
        path: `/admin/resources`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Resources
     * @name ResourcesAdminControllerCreateCategory
     * @request POST:/admin/resources/categories
     * @secure
     */
    resourcesAdminControllerCreateCategory: (data: CreateResourceCategoryDto, params: RequestParams = {}) =>
      this.request<ResourceCategoryDto, any>({
        path: `/admin/resources/categories`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Resources
     * @name ResourcesAdminControllerUpdateCategory
     * @request PATCH:/admin/resources/categories/{id}
     * @secure
     */
    resourcesAdminControllerUpdateCategory: (id: string, data: UpdateResourceCategoryDto, params: RequestParams = {}) =>
      this.request<ResourceCategoryDto, any>({
        path: `/admin/resources/categories/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Resources
     * @name ResourcesAdminControllerDeleteCategory
     * @request DELETE:/admin/resources/categories/{id}
     * @secure
     */
    resourcesAdminControllerDeleteCategory: (id: string, params: RequestParams = {}) =>
      this.request<ResourceCategoryDto, any>({
        path: `/admin/resources/categories/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Resources
     * @name ResourcesAdminControllerCreateResource
     * @request POST:/admin/resources/items
     * @secure
     */
    resourcesAdminControllerCreateResource: (data: CreateResourceDto, params: RequestParams = {}) =>
      this.request<ResourceDto, any>({
        path: `/admin/resources/items`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Resources
     * @name ResourcesAdminControllerUpdateResource
     * @request PATCH:/admin/resources/items/{id}
     * @secure
     */
    resourcesAdminControllerUpdateResource: (id: string, data: UpdateResourceDto, params: RequestParams = {}) =>
      this.request<ResourceDto, any>({
        path: `/admin/resources/items/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Resources
     * @name ResourcesAdminControllerDeleteResource
     * @request DELETE:/admin/resources/items/{id}
     * @secure
     */
    resourcesAdminControllerDeleteResource: (id: string, params: RequestParams = {}) =>
      this.request<ResourceDto, any>({
        path: `/admin/resources/items/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Resources
     * @name ResourcesAdminControllerUploadResourceImage
     * @request POST:/admin/resources/items/{id}/image
     * @secure
     */
    resourcesAdminControllerUploadResourceImage: (
      id: string,
      data: {
        /** @format binary */
        file: File;
      },
      params: RequestParams = {},
    ) =>
      this.request<ResourceDto, any>({
        path: `/admin/resources/items/${id}/image`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Resources
     * @name ResourcesAdminControllerDeleteResourceImage
     * @request DELETE:/admin/resources/items/{id}/image
     * @secure
     */
    resourcesAdminControllerDeleteResourceImage: (id: string, params: RequestParams = {}) =>
      this.request<ResourceDto, any>({
        path: `/admin/resources/items/${id}/image`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Communities
     * @name CommunitiesAdminControllerFindAll
     * @request GET:/admin/communities
     * @secure
     */
    communitiesAdminControllerFindAll: (params: RequestParams = {}) =>
      this.request<CommunitiesListDto, any>({
        path: `/admin/communities`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Communities
     * @name CommunitiesAdminControllerCreateCategory
     * @request POST:/admin/communities/categories
     * @secure
     */
    communitiesAdminControllerCreateCategory: (data: CreateCommunityCategoryDto, params: RequestParams = {}) =>
      this.request<CommunityCategoryDto, any>({
        path: `/admin/communities/categories`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Communities
     * @name CommunitiesAdminControllerUpdateCategory
     * @request PATCH:/admin/communities/categories/{id}
     * @secure
     */
    communitiesAdminControllerUpdateCategory: (
      id: string,
      data: UpdateCommunityCategoryDto,
      params: RequestParams = {},
    ) =>
      this.request<CommunityCategoryDto, any>({
        path: `/admin/communities/categories/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Communities
     * @name CommunitiesAdminControllerDeleteCategory
     * @request DELETE:/admin/communities/categories/{id}
     * @secure
     */
    communitiesAdminControllerDeleteCategory: (id: string, params: RequestParams = {}) =>
      this.request<CommunityCategoryDto, any>({
        path: `/admin/communities/categories/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Communities
     * @name CommunitiesAdminControllerCreateItem
     * @request POST:/admin/communities/items
     * @secure
     */
    communitiesAdminControllerCreateItem: (data: CreateCommunityItemDto, params: RequestParams = {}) =>
      this.request<CommunityItemDto, any>({
        path: `/admin/communities/items`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Communities
     * @name CommunitiesAdminControllerUpdateItem
     * @request PATCH:/admin/communities/items/{id}
     * @secure
     */
    communitiesAdminControllerUpdateItem: (id: string, data: UpdateCommunityItemDto, params: RequestParams = {}) =>
      this.request<CommunityItemDto, any>({
        path: `/admin/communities/items/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Communities
     * @name CommunitiesAdminControllerDeleteItem
     * @request DELETE:/admin/communities/items/{id}
     * @secure
     */
    communitiesAdminControllerDeleteItem: (id: string, params: RequestParams = {}) =>
      this.request<CommunityItemDto, any>({
        path: `/admin/communities/items/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Communities
     * @name CommunitiesAdminControllerUploadItemImage
     * @request POST:/admin/communities/items/{id}/image
     * @secure
     */
    communitiesAdminControllerUploadItemImage: (
      id: string,
      data: {
        /** @format binary */
        file: File;
      },
      params: RequestParams = {},
    ) =>
      this.request<CommunityItemDto, any>({
        path: `/admin/communities/items/${id}/image`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Communities
     * @name CommunitiesAdminControllerDeleteItemImage
     * @request DELETE:/admin/communities/items/{id}/image
     * @secure
     */
    communitiesAdminControllerDeleteItemImage: (id: string, params: RequestParams = {}) =>
      this.request<CommunityItemDto, any>({
        path: `/admin/communities/items/${id}/image`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  stripeSubscriptions = {
    /**
     * No description
     *
     * @name StripeSubscriptionsControllerFindUserSubscription
     * @request GET:/stripe-subscriptions/{userId}
     */
    stripeSubscriptionsControllerFindUserSubscription: (userId: string, params: RequestParams = {}) =>
      this.request<StripeSubscriptionsDto, any>({
        path: `/stripe-subscriptions/${userId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name StripeSubscriptionsControllerPause
     * @request PATCH:/stripe-subscriptions/{id}/pause
     */
    stripeSubscriptionsControllerPause: (id: string, data: PauseStripeSubscriptionDto, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/stripe-subscriptions/${id}/pause`,
        method: "PATCH",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @name StripeSubscriptionsControllerResume
     * @request PATCH:/stripe-subscriptions/{id}/resume
     */
    stripeSubscriptionsControllerResume: (id: string, data: ResumeStripeSubscriptionDto, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/stripe-subscriptions/${id}/resume`,
        method: "PATCH",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @name StripeSubscriptionsControllerCancel
     * @request PATCH:/stripe-subscriptions/{id}/cancel
     */
    stripeSubscriptionsControllerCancel: (id: string, data: CancelStripeSubscriptionDto, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/stripe-subscriptions/${id}/cancel`,
        method: "PATCH",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @name StripeSubscriptionsControllerCancelAtEnd
     * @request PATCH:/stripe-subscriptions/{id}/cancel-at-period-end
     */
    stripeSubscriptionsControllerCancelAtEnd: (
      id: string,
      data: CancelStripeSubscriptionDto,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/stripe-subscriptions/${id}/cancel-at-period-end`,
        method: "PATCH",
        body: data,
        type: ContentType.Json,
        ...params,
      }),
  };
  industryFeedAggregator = {
    /**
     * No description
     *
     * @name IndustryFeedAggregatorControllerGetNews
     * @request GET:/industry-feed-aggregator/news
     */
    industryFeedAggregatorControllerGetNews: (
      query?: {
        /**
         * @min 0
         * @default 0
         */
        offset?: number | null;
        /**
         * @max 100
         * @default 20
         */
        limit?: number;
        source?: ("Event Industry News" | "Music Business Worldwide" | "SoundGirls" | "Billboard" | "manual")[];
      },
      params: RequestParams = {},
    ) =>
      this.request<IndustryFeedListResponseDto, any>({
        path: `/industry-feed-aggregator/news`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name IndustryFeedAggregatorControllerGetOpportunities
     * @request GET:/industry-feed-aggregator/opportunities
     */
    industryFeedAggregatorControllerGetOpportunities: (
      query?: {
        /**
         * @min 0
         * @default 0
         */
        offset?: number | null;
        /**
         * @max 100
         * @default 20
         */
        limit?: number;
        source?: ("Live Nation" | "Ticketmaster" | "manual")[];
      },
      params: RequestParams = {},
    ) =>
      this.request<IndustryFeedListResponseDto, any>({
        path: `/industry-feed-aggregator/opportunities`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name IndustryFeedAggregatorControllerGetInformation
     * @request GET:/industry-feed-aggregator/information
     */
    industryFeedAggregatorControllerGetInformation: (
      query?: {
        /**
         * @min 0
         * @default 0
         */
        offset?: number | null;
        /**
         * @max 100
         * @default 20
         */
        limit?: number;
        source?: ("Backline.care" | "Vision for Sustainable Events" | "A Greener Future" | "LASSO" | "manual")[];
      },
      params: RequestParams = {},
    ) =>
      this.request<IndustryFeedListResponseDto, any>({
        path: `/industry-feed-aggregator/information`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name IndustryFeedAggregatorAdminControllerCreateItem
     * @request POST:/industry-feed-aggregator/admin/items
     */
    industryFeedAggregatorAdminControllerCreateItem: (
      data: CreateIndustryFeedAdminItemDto,
      params: RequestParams = {},
    ) =>
      this.request<IndustryFeedItemDto, any>({
        path: `/industry-feed-aggregator/admin/items`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  upload = {
    /**
     * No description
     *
     * @name UploadControllerGetDownloadUrl
     * @request POST:/upload/download-url
     */
    uploadControllerGetDownloadUrl: (data: FileKeyDto, params: RequestParams = {}) =>
      this.request<UploadedFileDto, any>({
        path: `/upload/download-url`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name UploadControllerGetDownloadUrls
     * @request POST:/upload/download-urls
     */
    uploadControllerGetDownloadUrls: (data: FileKeysDto, params: RequestParams = {}) =>
      this.request<BulkDownloadUrlItemDto[], any>({
        path: `/upload/download-urls`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  events = {
    /**
     * No description
     *
     * @name EventsV1ControllerDuplicate
     * @request POST:/events/duplicate
     */
    eventsV1ControllerDuplicate: (data: DuplicateEventV1Dto, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/events/duplicate`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @name EventsV1ControllerCreate
     * @request POST:/events/{tourId}
     */
    eventsV1ControllerCreate: (tourId: string, data: CreateEventV1Dto, params: RequestParams = {}) =>
      this.request<EventV1Dto, any>({
        path: `/events/${tourId}`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name EventsV1ControllerFindAllByTour
     * @request GET:/events/tour/{tourId}
     */
    eventsV1ControllerFindAllByTour: (
      tourId: string,
      query?: {
        /** @format date-time */
        from?: string | null;
        /** @format date-time */
        to?: string | null;
        typeId?: string | null;
        /** Array of UUIDs */
        artistIds?: any[] | null;
        /** Array of UUIDs */
        groupIds?: any[] | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<EventsV1Dto, any>({
        path: `/events/tour/${tourId}`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name EventsV1ControllerFindUpcoming
     * @request GET:/events/upcoming
     */
    eventsV1ControllerFindUpcoming: (
      query?: {
        /** @format date-time */
        from?: string | null;
        /** @format date-time */
        to?: string | null;
        typeId?: string | null;
        /** Array of UUIDs */
        artistIds?: any[] | null;
        /** Array of UUIDs */
        groupIds?: any[] | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<EventsV1Dto, any>({
        path: `/events/upcoming`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name EventsV1ControllerFindAll
     * @request GET:/events/types
     */
    eventsV1ControllerFindAll: (
      query?: {
        web_fix?: boolean | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<EventTypesV1Dto, any>({
        path: `/events/types`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name EventsV1ControllerFindOne
     * @request GET:/events/{id}
     */
    eventsV1ControllerFindOne: (id: string, params: RequestParams = {}) =>
      this.request<EventV1Dto, any>({
        path: `/events/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name EventsV1ControllerUpdate
     * @request PATCH:/events/{id}
     */
    eventsV1ControllerUpdate: (id: string, data: UpdateEventV1Dto, params: RequestParams = {}) =>
      this.request<EventV1Dto, any>({
        path: `/events/${id}`,
        method: "PATCH",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name EventsV1ControllerRemove
     * @request DELETE:/events/{id}
     */
    eventsV1ControllerRemove: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/events/${id}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * No description
     *
     * @name EventsV1ControllerCreatePersonnel
     * @request POST:/events/{id}/personnel
     */
    eventsV1ControllerCreatePersonnel: (id: string, data: CreateEventPersonnelDto, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/events/${id}/personnel`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @name EventsV1ControllerFindAllPersonnel
     * @request GET:/events/{id}/personnel
     */
    eventsV1ControllerFindAllPersonnel: (id: string, params: RequestParams = {}) =>
      this.request<EventPersonnelDto, any>({
        path: `/events/${id}/personnel`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name EventsV1ControllerCreatePersonnelGroup
     * @request POST:/events/{id}/personnel-groups
     */
    eventsV1ControllerCreatePersonnelGroup: (
      id: string,
      data: CreateEventPersonnelGroupDto,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/events/${id}/personnel-groups`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @name EventsV1ControllerRemovePersonnel
     * @request DELETE:/events/{id}/personnel/{personnelId}
     */
    eventsV1ControllerRemovePersonnel: (id: string, personnelId: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/events/${id}/personnel/${personnelId}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * No description
     *
     * @name EventsV1ControllerUpdatePersonnel
     * @request PATCH:/events/{id}/personnel/{personnelId}
     */
    eventsV1ControllerUpdatePersonnel: (
      id: string,
      personnelId: string,
      data: UpdateEventPersonnelDto,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/events/${id}/personnel/${personnelId}`,
        method: "PATCH",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @name EventsV1ControllerCreateGuestListSubmission
     * @request POST:/events/{id}/guest-list-submissions
     */
    eventsV1ControllerCreateGuestListSubmission: (
      id: string,
      data: CreateGuestListSubmissionDto,
      params: RequestParams = {},
    ) =>
      this.request<UserGuestListSubmissionDto, any>({
        path: `/events/${id}/guest-list-submissions`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name EventsV1ControllerGetGuestListSubmissions
     * @request GET:/events/{id}/guest-list-submissions
     */
    eventsV1ControllerGetGuestListSubmissions: (id: string, params: RequestParams = {}) =>
      this.request<GuestListSubmissionsDto, any>({
        path: `/events/${id}/guest-list-submissions`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name EventsV1ControllerUpdateGuestListSubmission
     * @request PATCH:/events/{id}/guest-list-submissions/{submissionId}
     */
    eventsV1ControllerUpdateGuestListSubmission: (
      id: string,
      submissionId: string,
      data: UpdateGuestListSubmissionDto,
      params: RequestParams = {},
    ) =>
      this.request<ManagerGuestListSubmissionDto, any>({
        path: `/events/${id}/guest-list-submissions/${submissionId}`,
        method: "PATCH",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  v2 = {
    /**
     * No description
     *
     * @name EventsV2ControllerFindAllByTour
     * @request GET:/v2/events/tour/{tourId}
     */
    eventsV2ControllerFindAllByTour: (
      tourId: string,
      query?: {
        /** @format date-time */
        from?: string | null;
        /** @format date-time */
        to?: string | null;
        typeId?: string | null;
        /** Array of UUIDs */
        artistIds?: any[] | null;
        /** Array of UUIDs */
        groupIds?: any[] | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<EventsV2Dto, any>({
        path: `/v2/events/tour/${tourId}`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name EventsV2ControllerFindUpcoming
     * @request GET:/v2/events/upcoming
     */
    eventsV2ControllerFindUpcoming: (
      query?: {
        /** @format date-time */
        from?: string | null;
        /** @format date-time */
        to?: string | null;
        typeId?: string | null;
        /** Array of UUIDs */
        artistIds?: any[] | null;
        /** Array of UUIDs */
        groupIds?: any[] | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<EventsV2Dto, any>({
        path: `/v2/events/upcoming`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name EventsV2ControllerFindOne
     * @request GET:/v2/events/{id}
     */
    eventsV2ControllerFindOne: (id: string, params: RequestParams = {}) =>
      this.request<EventV2Dto, any>({
        path: `/v2/events/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name EventsV2ControllerCreateWithTemplate
     * @request POST:/v2/events/{tourId}/with-template
     */
    eventsV2ControllerCreateWithTemplate: (tourId: string, data: CreateWithTemplateDto, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/v2/events/${tourId}/with-template`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @name EventsV2ControllerOverrideWithTemplate
     * @request POST:/v2/events/{tourId}/override-with-template
     */
    eventsV2ControllerOverrideWithTemplate: (
      tourId: string,
      data: OverrideWithTemplateDto,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/v2/events/${tourId}/override-with-template`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @name EventsV2ControllerCreateMultiLeg
     * @request POST:/v2/events/{tourId}/multi-legs
     */
    eventsV2ControllerCreateMultiLeg: (tourId: string, data: CreateMultiLegEventsDto, params: RequestParams = {}) =>
      this.request<MultiLegEventsV2Dto, any>({
        path: `/v2/events/${tourId}/multi-legs`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name EventsV2ControllerFindByMultiLeg
     * @request GET:/v2/events/tour/{tourId}/multi-legs/{multiLegId}
     */
    eventsV2ControllerFindByMultiLeg: (tourId: string, multiLegId: string, params: RequestParams = {}) =>
      this.request<MultiLegEventsV2Dto, any>({
        path: `/v2/events/tour/${tourId}/multi-legs/${multiLegId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name EventsV2ControllerSendEventReminder
     * @request POST:/v2/events/{id}/send-reminder
     */
    eventsV2ControllerSendEventReminder: (id: string, data: SendEventReminderDto, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/v2/events/${id}/send-reminder`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),
  };
  notifications = {
    /**
     * No description
     *
     * @name NotificationsControllerSendNotification
     * @request POST:/notifications
     */
    notificationsControllerSendNotification: (data: SendNotificationDto, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/notifications`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @name NotificationsControllerCreateMobileDevice
     * @request POST:/notifications/mobile-device
     */
    notificationsControllerCreateMobileDevice: (data: CreateMobileDeviceDto, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/notifications/mobile-device`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @name NotificationsControllerDeleteMobileDevice
     * @request DELETE:/notifications/mobile-device
     */
    notificationsControllerDeleteMobileDevice: (data: RevokeMobileDeviceDto, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/notifications/mobile-device`,
        method: "DELETE",
        body: data,
        type: ContentType.Json,
        ...params,
      }),
  };
  eventReminders = {
    /**
     * No description
     *
     * @tags Event Reminders
     * @name EventRemindersControllerCreate
     * @request POST:/event-reminders
     */
    eventRemindersControllerCreate: (data: CreateEventReminderDto, params: RequestParams = {}) =>
      this.request<EventReminderDto, any>({
        path: `/event-reminders`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Event Reminders
     * @name EventRemindersControllerFindAll
     * @request GET:/event-reminders
     */
    eventRemindersControllerFindAll: (
      query?: {
        reminderType?: "team" | "personal";
        status?: "pending" | "sent" | "failed" | "cancelled";
        /** Filter by event ID */
        eventId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<EventRemindersDto, any>({
        path: `/event-reminders`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Event Reminders
     * @name EventRemindersControllerFindOne
     * @request GET:/event-reminders/{id}
     */
    eventRemindersControllerFindOne: (id: string, params: RequestParams = {}) =>
      this.request<EventReminderDto, any>({
        path: `/event-reminders/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Event Reminders
     * @name EventRemindersControllerUpdate
     * @request PATCH:/event-reminders/{id}
     */
    eventRemindersControllerUpdate: (id: string, data: UpdateEventReminderDto, params: RequestParams = {}) =>
      this.request<EventReminderDto, any>({
        path: `/event-reminders/${id}`,
        method: "PATCH",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Event Reminders
     * @name EventRemindersControllerRemove
     * @request DELETE:/event-reminders/{id}
     */
    eventRemindersControllerRemove: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/event-reminders/${id}`,
        method: "DELETE",
        ...params,
      }),
  };
  mails = {
    /**
     * No description
     *
     * @name MailControllerSendEmail
     * @request POST:/mails
     */
    mailControllerSendEmail: (data: SendEmailDto, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/mails`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),
  };
  eventProviders = {
    /**
     * No description
     *
     * @name EventProvidersControllerCreate
     * @request POST:/event-providers
     */
    eventProvidersControllerCreate: (data: CreateEventProviderDto, params: RequestParams = {}) =>
      this.request<EventProviderDto, any>({
        path: `/event-providers`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name EventProvidersControllerUpdate
     * @request PATCH:/event-providers/{id}
     */
    eventProvidersControllerUpdate: (id: string, data: UpdateEventProviderDto, params: RequestParams = {}) =>
      this.request<EventProviderDto, any>({
        path: `/event-providers/${id}`,
        method: "PATCH",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name EventProvidersControllerRemove
     * @request DELETE:/event-providers/{id}
     */
    eventProvidersControllerRemove: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/event-providers/${id}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * No description
     *
     * @name EventProvidersControllerFindOne
     * @request GET:/event-providers/{id}
     */
    eventProvidersControllerFindOne: (id: string, params: RequestParams = {}) =>
      this.request<EventProviderDto, any>({
        path: `/event-providers/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name EventProvidersControllerFindAll
     * @request GET:/event-providers/workspace/{workspaceId}
     */
    eventProvidersControllerFindAll: (workspaceId: string, params: RequestParams = {}) =>
      this.request<EventProvidersDto, any>({
        path: `/event-providers/workspace/${workspaceId}`,
        method: "GET",
        format: "json",
        ...params,
      }),
  };
  dayTags = {
    /**
     * No description
     *
     * @name DayTagsControllerFindAll
     * @request GET:/day-tags/{workspaceId}
     */
    dayTagsControllerFindAll: (workspaceId: string, params: RequestParams = {}) =>
      this.request<DayTagsDto, any>({
        path: `/day-tags/${workspaceId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name DayTagsControllerCreate
     * @request POST:/day-tags
     */
    dayTagsControllerCreate: (data: CreateDayTagDto, params: RequestParams = {}) =>
      this.request<DayTagDto, any>({
        path: `/day-tags`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name DayTagsControllerRemove
     * @request DELETE:/day-tags/{id}
     */
    dayTagsControllerRemove: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/day-tags/${id}`,
        method: "DELETE",
        ...params,
      }),
  };
  tourDays = {
    /**
     * No description
     *
     * @name TourDaysControllerFindAll
     * @request GET:/tour-days/{tourId}
     */
    tourDaysControllerFindAll: (tourId: string, params: RequestParams = {}) =>
      this.request<TourDaysDto, any>({
        path: `/tour-days/${tourId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name TourDaysControllerCreate
     * @request POST:/tour-days/{tourId}
     */
    tourDaysControllerCreate: (tourId: string, data: CreateTourDayDto, params: RequestParams = {}) =>
      this.request<CreatedTourDayDto, any>({
        path: `/tour-days/${tourId}`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name TourDaysControllerCreateNote
     * @request POST:/tour-days/{tourId}/notes
     */
    tourDaysControllerCreateNote: (tourId: string, data: CreateTourDayNoteDto, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/tour-days/${tourId}/notes`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @name TourDaysControllerUpdateNote
     * @request PATCH:/tour-days/{tourId}/notes/{id}
     */
    tourDaysControllerUpdateNote: (
      tourId: string,
      id: string,
      data: UpdateTourDayNoteDto,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/tour-days/${tourId}/notes/${id}`,
        method: "PATCH",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @name TourDaysControllerRemoveNote
     * @request DELETE:/tour-days/{tourId}/notes/{id}
     */
    tourDaysControllerRemoveNote: (tourId: string, id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/tour-days/${tourId}/notes/${id}`,
        method: "DELETE",
        ...params,
      }),
  };
  eventPersonnelRoles = {
    /**
     * No description
     *
     * @name EventPersonnelRolesControllerFindAll
     * @request GET:/event-personnel-roles
     */
    eventPersonnelRolesControllerFindAll: (params: RequestParams = {}) =>
      this.request<EventPersonnelRolesDto, any>({
        path: `/event-personnel-roles`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name EventPersonnelRolesControllerFindOne
     * @request GET:/event-personnel-roles/{id}
     */
    eventPersonnelRolesControllerFindOne: (id: string, params: RequestParams = {}) =>
      this.request<EventPersonnelRoleDto, any>({
        path: `/event-personnel-roles/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),
  };
  tableColumns = {
    /**
     * No description
     *
     * @name TableColumnsControllerFindAll
     * @request GET:/table-columns
     */
    tableColumnsControllerFindAll: (params: RequestParams = {}) =>
      this.request<TableColumnsDto, any>({
        path: `/table-columns`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name TableColumnsControllerFindSupplementalQuestions
     * @request GET:/table-columns/supplemental-questions
     */
    tableColumnsControllerFindSupplementalQuestions: (params: RequestParams = {}) =>
      this.request<TableColumnsSupplementalQuestionsDto, any>({
        path: `/table-columns/supplemental-questions`,
        method: "GET",
        format: "json",
        ...params,
      }),
  };
  reportTemplates = {
    /**
     * No description
     *
     * @name ReportTemplatesControllerCreate
     * @request POST:/report-templates
     */
    reportTemplatesControllerCreate: (data: CreateReportTemplateDto, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/report-templates`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @name ReportTemplatesControllerFindAll
     * @request GET:/report-templates/{workspaceId}
     */
    reportTemplatesControllerFindAll: (workspaceId: string, params: RequestParams = {}) =>
      this.request<ReportTemplatesDto, any>({
        path: `/report-templates/${workspaceId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name ReportTemplatesControllerFindReports
     * @request GET:/report-templates/{id}/reports
     */
    reportTemplatesControllerFindReports: (id: string, params: RequestParams = {}) =>
      this.request<ReportTemplatesDto, any>({
        path: `/report-templates/${id}/reports`,
        method: "GET",
        format: "json",
        ...params,
      }),
  };
  reports = {
    /**
     * No description
     *
     * @name ReportsControllerCreate
     * @request POST:/reports
     */
    reportsControllerCreate: (data: CreateReportDto, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/reports`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @name ReportsControllerFindAllByTour
     * @request GET:/reports
     */
    reportsControllerFindAllByTour: (
      query?: {
        reportTemplateId?: string | null;
        tourId?: string | null;
        workspaceId?: string | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<ReportsDto, any>({
        path: `/reports`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name ReportsControllerFindOne
     * @request GET:/reports/{id}
     */
    reportsControllerFindOne: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/reports/${id}`,
        method: "GET",
        ...params,
      }),
  };
  groups = {
    /**
     * No description
     *
     * @name GroupsControllerCreate
     * @request POST:/groups/{tourId}
     */
    groupsControllerCreate: (tourId: string, data: CreateGroupDto, params: RequestParams = {}) =>
      this.request<GroupDto, any>({
        path: `/groups/${tourId}`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name GroupsControllerFindAllByTour
     * @request GET:/groups/tour/{tourId}
     */
    groupsControllerFindAllByTour: (tourId: string, params: RequestParams = {}) =>
      this.request<GroupsDto, any>({
        path: `/groups/tour/${tourId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name GroupsControllerFindOne
     * @request GET:/groups/{id}
     */
    groupsControllerFindOne: (id: string, params: RequestParams = {}) =>
      this.request<GroupDto, any>({
        path: `/groups/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name GroupsControllerUpdate
     * @request PATCH:/groups/{id}
     */
    groupsControllerUpdate: (id: string, data: UpdateGroupDto, params: RequestParams = {}) =>
      this.request<GroupDto, any>({
        path: `/groups/${id}`,
        method: "PATCH",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name GroupsControllerRemove
     * @request DELETE:/groups/{id}
     */
    groupsControllerRemove: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/groups/${id}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * No description
     *
     * @name GroupsControllerCreatePersonnel
     * @request POST:/groups/{id}/members
     */
    groupsControllerCreatePersonnel: (id: string, data: CreateGroupMembersDto, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/groups/${id}/members`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @name GroupsControllerFindAllPersonnel
     * @request GET:/groups/{id}/members
     */
    groupsControllerFindAllPersonnel: (id: string, params: RequestParams = {}) =>
      this.request<GroupMembersArrayDto, any>({
        path: `/groups/${id}/members`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name GroupsControllerFindOnePersonnel
     * @request GET:/groups/{id}/members/{memberId}
     */
    groupsControllerFindOnePersonnel: (id: string, memberId: string, params: RequestParams = {}) =>
      this.request<GroupMemberDto, any>({
        path: `/groups/${id}/members/${memberId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name GroupsControllerRemovePersonnel
     * @request DELETE:/groups/{id}/members/{memberId}
     */
    groupsControllerRemovePersonnel: (id: string, memberId: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/groups/${id}/members/${memberId}`,
        method: "DELETE",
        ...params,
      }),
  };
  reportFiles = {
    /**
     * No description
     *
     * @name ReportFilesControllerDownloadReportFiles
     * @request GET:/report-files/download/{reportId}
     */
    reportFilesControllerDownloadReportFiles: (reportId: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/report-files/download/${reportId}`,
        method: "GET",
        ...params,
      }),
  };
  riders = {
    /**
     * No description
     *
     * @name RidersControllerFindAllTypes
     * @request GET:/riders/types
     */
    ridersControllerFindAllTypes: (params: RequestParams = {}) =>
      this.request<RiderTypesDto, any>({
        path: `/riders/types`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name RidersControllerCreate
     * @request POST:/riders/tour/{tourId}
     */
    ridersControllerCreate: (tourId: string, data: CreateRiderDto, params: RequestParams = {}) =>
      this.request<RiderDto, any>({
        path: `/riders/tour/${tourId}`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name RidersControllerFindAllByTour
     * @request GET:/riders/tour/{tourId}
     */
    ridersControllerFindAllByTour: (tourId: string, params: RequestParams = {}) =>
      this.request<RidersDto, any>({
        path: `/riders/tour/${tourId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name RidersControllerFindOne
     * @request GET:/riders/{id}
     */
    ridersControllerFindOne: (id: string, params: RequestParams = {}) =>
      this.request<RiderDto, any>({
        path: `/riders/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name RidersControllerUpdate
     * @request PATCH:/riders/{id}
     */
    ridersControllerUpdate: (id: string, data: UpdateRiderDto, params: RequestParams = {}) =>
      this.request<RiderDto, any>({
        path: `/riders/${id}`,
        method: "PATCH",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name RidersControllerRemove
     * @request DELETE:/riders/{id}
     */
    ridersControllerRemove: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/riders/${id}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * No description
     *
     * @name RidersControllerCreatePersonnel
     * @request POST:/riders/{id}/personnel
     */
    ridersControllerCreatePersonnel: (id: string, data: CreateRiderPersonnelDto, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/riders/${id}/personnel`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @name RidersControllerFindAllPersonnel
     * @request GET:/riders/{id}/personnel
     */
    ridersControllerFindAllPersonnel: (id: string, params: RequestParams = {}) =>
      this.request<RiderPersonnelArrayDto, any>({
        path: `/riders/${id}/personnel`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name RidersControllerFindOnePersonnel
     * @request GET:/riders/{id}/personnel/{personnelId}
     */
    ridersControllerFindOnePersonnel: (id: string, personnelId: string, params: RequestParams = {}) =>
      this.request<RiderPersonnelDto, any>({
        path: `/riders/${id}/personnel/${personnelId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name RidersControllerRemovePersonnel
     * @request DELETE:/riders/{id}/personnel/{personnelId}
     */
    ridersControllerRemovePersonnel: (id: string, personnelId: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/riders/${id}/personnel/${personnelId}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * No description
     *
     * @name RidersControllerCreateExternalPersonnel
     * @request POST:/riders/{id}/external-personnel
     */
    ridersControllerCreateExternalPersonnel: (
      id: string,
      data: CreateExternalRiderPersonnelDto,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/riders/${id}/external-personnel`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @name RidersControllerFindAllExternalPersonnel
     * @request GET:/riders/{id}/external-personnel
     */
    ridersControllerFindAllExternalPersonnel: (id: string, params: RequestParams = {}) =>
      this.request<ExternalRiderPersonnelArrayDto, any>({
        path: `/riders/${id}/external-personnel`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name RidersControllerFindOneExternalPersonnel
     * @request GET:/riders/{id}/external-personnel/{personnelId}
     */
    ridersControllerFindOneExternalPersonnel: (personnelId: string, id: string, params: RequestParams = {}) =>
      this.request<RiderPersonnelDto, any>({
        path: `/riders/${id}/external-personnel/${personnelId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name RidersControllerUpdatePersonnel
     * @request PATCH:/riders/{id}/external-personnel/{personnelId}
     */
    ridersControllerUpdatePersonnel: (
      personnelId: string,
      id: string,
      data: UpdateExternalRiderPersonnelDto,
      params: RequestParams = {},
    ) =>
      this.request<ExternalRiderPersonnelDto, any>({
        path: `/riders/${id}/external-personnel/${personnelId}`,
        method: "PATCH",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name RidersControllerRemoveExternalPersonnel
     * @request DELETE:/riders/{id}/external-personnel/{personnelId}
     */
    ridersControllerRemoveExternalPersonnel: (personnelId: string, id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/riders/${id}/external-personnel/${personnelId}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * No description
     *
     * @name RidersControllerUploadFile
     * @request POST:/riders/{id}/upload-file
     */
    ridersControllerUploadFile: (id: string, data: UploadRiderFileDto, params: RequestParams = {}) =>
      this.request<UploadedFileKeyDto, any>({
        path: `/riders/${id}/upload-file`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name RidersControllerDeleteFile
     * @request DELETE:/riders/{id}/delete-file
     */
    ridersControllerDeleteFile: (id: string, data: DeleteRiderFileDto, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/riders/${id}/delete-file`,
        method: "DELETE",
        body: data,
        type: ContentType.Json,
        ...params,
      }),
  };
  riderLabors = {
    /**
     * No description
     *
     * @name RiderLaborsControllerCreate
     * @request POST:/rider-labors
     */
    riderLaborsControllerCreate: (data: CreateRiderLaborDto, params: RequestParams = {}) =>
      this.request<RiderLaborDto, any>({
        path: `/rider-labors`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name RiderLaborsControllerFindAllByRiderLabor
     * @request GET:/rider-labors/rider/{riderId}
     */
    riderLaborsControllerFindAllByRiderLabor: (riderId: string, params: RequestParams = {}) =>
      this.request<RiderLaborsDto, any>({
        path: `/rider-labors/rider/${riderId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name RiderLaborsControllerFindOne
     * @request GET:/rider-labors/{id}
     */
    riderLaborsControllerFindOne: (id: string, params: RequestParams = {}) =>
      this.request<RiderLaborDto, any>({
        path: `/rider-labors/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name RiderLaborsControllerUpdate
     * @request PATCH:/rider-labors/{id}
     */
    riderLaborsControllerUpdate: (id: string, data: UpdateRiderLaborDto, params: RequestParams = {}) =>
      this.request<RiderLaborDto, any>({
        path: `/rider-labors/${id}`,
        method: "PATCH",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name RiderLaborsControllerRemove
     * @request DELETE:/rider-labors/{id}
     */
    riderLaborsControllerRemove: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/rider-labors/${id}`,
        method: "DELETE",
        ...params,
      }),
  };
  riderSupportingActs = {
    /**
     * No description
     *
     * @name RiderSupportingActsControllerCreate
     * @request POST:/rider-supporting-acts
     */
    riderSupportingActsControllerCreate: (data: CreateRiderSupportingActDto, params: RequestParams = {}) =>
      this.request<RiderSupportingActDto, any>({
        path: `/rider-supporting-acts`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name RiderSupportingActsControllerFindAllByRider
     * @request GET:/rider-supporting-acts/rider/{riderId}
     */
    riderSupportingActsControllerFindAllByRider: (riderId: string, params: RequestParams = {}) =>
      this.request<RiderSupportingActsDto, any>({
        path: `/rider-supporting-acts/rider/${riderId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name RiderSupportingActsControllerFindOne
     * @request GET:/rider-supporting-acts/{id}
     */
    riderSupportingActsControllerFindOne: (id: string, params: RequestParams = {}) =>
      this.request<RiderSupportingActDto, any>({
        path: `/rider-supporting-acts/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name RiderSupportingActsControllerUpdate
     * @request PATCH:/rider-supporting-acts/{id}
     */
    riderSupportingActsControllerUpdate: (id: string, data: UpdateRiderSupportingActDto, params: RequestParams = {}) =>
      this.request<RiderSupportingActDto, any>({
        path: `/rider-supporting-acts/${id}`,
        method: "PATCH",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name RiderSupportingActsControllerRemove
     * @request DELETE:/rider-supporting-acts/{id}
     */
    riderSupportingActsControllerRemove: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/rider-supporting-acts/${id}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * No description
     *
     * @name RiderSupportingActsControllerUploadFile
     * @request POST:/rider-supporting-acts/{id}/upload-file
     */
    riderSupportingActsControllerUploadFile: (
      id: string,
      data: UploadRiderSupportingActFileDto,
      params: RequestParams = {},
    ) =>
      this.request<UploadedFileKeyDto, any>({
        path: `/rider-supporting-acts/${id}/upload-file`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name RiderSupportingActsControllerDeleteFile
     * @request DELETE:/rider-supporting-acts/{id}/delete-file
     */
    riderSupportingActsControllerDeleteFile: (
      id: string,
      data: DeleteRiderSupportingActFileDto,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/rider-supporting-acts/${id}/delete-file`,
        method: "DELETE",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @name RiderSupportingActsControllerCreateSupportingActPersonnel
     * @request POST:/rider-supporting-acts/{id}/personnel
     */
    riderSupportingActsControllerCreateSupportingActPersonnel: (
      id: string,
      data: CreateSupportingActPersonnelDto,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/rider-supporting-acts/${id}/personnel`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @name RiderSupportingActsControllerFindAllSupportingActPersonnel
     * @request GET:/rider-supporting-acts/{id}/personnel
     */
    riderSupportingActsControllerFindAllSupportingActPersonnel: (id: string, params: RequestParams = {}) =>
      this.request<SupportingActPersonnelArrayDto, any>({
        path: `/rider-supporting-acts/${id}/personnel`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name RiderSupportingActsControllerFindOneSupportingActPersonnel
     * @request GET:/rider-supporting-acts/{id}/personnel/{personnelId}
     */
    riderSupportingActsControllerFindOneSupportingActPersonnel: (
      personnelId: string,
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<SupportingActPersonnelDto, any>({
        path: `/rider-supporting-acts/${id}/personnel/${personnelId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name RiderSupportingActsControllerUpdatePersonnel
     * @request PATCH:/rider-supporting-acts/{id}/personnel/{personnelId}
     */
    riderSupportingActsControllerUpdatePersonnel: (
      personnelId: string,
      id: string,
      data: UpdateSupportingActPersonnelDto,
      params: RequestParams = {},
    ) =>
      this.request<SupportingActPersonnelDto, any>({
        path: `/rider-supporting-acts/${id}/personnel/${personnelId}`,
        method: "PATCH",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name RiderSupportingActsControllerRemoveSupportingActPersonnel
     * @request DELETE:/rider-supporting-acts/{id}/personnel/{personnelId}
     */
    riderSupportingActsControllerRemoveSupportingActPersonnel: (
      personnelId: string,
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/rider-supporting-acts/${id}/personnel/${personnelId}`,
        method: "DELETE",
        ...params,
      }),
  };
  personalEvents = {
    /**
     * No description
     *
     * @name PersonalEventsControllerCreate
     * @request POST:/personal-events
     */
    personalEventsControllerCreate: (data: CreatePersonalEventDto, params: RequestParams = {}) =>
      this.request<PersonalEventDto, any>({
        path: `/personal-events`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name PersonalEventsControllerFindAll
     * @request GET:/personal-events
     */
    personalEventsControllerFindAll: (params: RequestParams = {}) =>
      this.request<PersonalEventsDto, any>({
        path: `/personal-events`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name PersonalEventsControllerFindOne
     * @request GET:/personal-events/{id}
     */
    personalEventsControllerFindOne: (id: string, params: RequestParams = {}) =>
      this.request<PersonalEventDto, any>({
        path: `/personal-events/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name PersonalEventsControllerUpdate
     * @request PATCH:/personal-events/{id}
     */
    personalEventsControllerUpdate: (id: string, data: UpdatePersonalEventDto, params: RequestParams = {}) =>
      this.request<PersonalEventDto, any>({
        path: `/personal-events/${id}`,
        method: "PATCH",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name PersonalEventsControllerRemove
     * @request DELETE:/personal-events/{id}
     */
    personalEventsControllerRemove: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/personal-events/${id}`,
        method: "DELETE",
        ...params,
      }),
  };
  chatRooms = {
    /**
     * No description
     *
     * @name ChatRoomsControllerCreate
     * @request POST:/chat-rooms
     */
    chatRoomsControllerCreate: (data: CreateChatRoomDto, params: RequestParams = {}) =>
      this.request<ChatRoomDto, any>({
        path: `/chat-rooms`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name ChatRoomsControllerFindAll
     * @request GET:/chat-rooms
     */
    chatRoomsControllerFindAll: (params: RequestParams = {}) =>
      this.request<ChatRoomsDto, any>({
        path: `/chat-rooms`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name ChatRoomsControllerFindUnreadMessages
     * @request GET:/chat-rooms/unread-messages
     */
    chatRoomsControllerFindUnreadMessages: (params: RequestParams = {}) =>
      this.request<UnreadMessagesDto, any>({
        path: `/chat-rooms/unread-messages`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name ChatRoomsControllerFindOne
     * @request GET:/chat-rooms/{id}
     */
    chatRoomsControllerFindOne: (id: string, params: RequestParams = {}) =>
      this.request<ChatRoomDto, any>({
        path: `/chat-rooms/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name ChatRoomsControllerUpdate
     * @request PATCH:/chat-rooms/{id}
     */
    chatRoomsControllerUpdate: (id: string, data: UpdateChatRoomDto, params: RequestParams = {}) =>
      this.request<ChatRoomDto, any>({
        path: `/chat-rooms/${id}`,
        method: "PATCH",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name ChatRoomsControllerArchive
     * @request PATCH:/chat-rooms/{id}/archive
     */
    chatRoomsControllerArchive: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/chat-rooms/${id}/archive`,
        method: "PATCH",
        ...params,
      }),

    /**
     * No description
     *
     * @name ChatRoomsControllerVisit
     * @request PATCH:/chat-rooms/{id}/visit
     */
    chatRoomsControllerVisit: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/chat-rooms/${id}/visit`,
        method: "PATCH",
        ...params,
      }),

    /**
     * No description
     *
     * @name ChatRoomsControllerCreatePersonnel
     * @request POST:/chat-rooms/{id}/members
     */
    chatRoomsControllerCreatePersonnel: (id: string, data: CreateChatRoomMembersDto, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/chat-rooms/${id}/members`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @name ChatRoomsControllerRemovePersonnel
     * @request DELETE:/chat-rooms/{id}/members/{memberId}
     */
    chatRoomsControllerRemovePersonnel: (id: string, memberId: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/chat-rooms/${id}/members/${memberId}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * No description
     *
     * @name ChatRoomsControllerSendMessage
     * @request POST:/chat-rooms/{id}/messages
     */
    chatRoomsControllerSendMessage: (id: string, data: CreateMessageDto, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/chat-rooms/${id}/messages`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @name ChatRoomsControllerFindMessages
     * @request GET:/chat-rooms/{id}/messages
     */
    chatRoomsControllerFindMessages: (id: string, params: RequestParams = {}) =>
      this.request<MessagesDto, any>({
        path: `/chat-rooms/${id}/messages`,
        method: "GET",
        format: "json",
        ...params,
      }),
  };
  accommodationRooms = {
    /**
     * No description
     *
     * @name AccommodationRoomsControllerCreate
     * @request POST:/accommodation-rooms/{eventId}
     */
    accommodationRoomsControllerCreate: (
      eventId: string,
      data: CreateAccommodationRoomDto,
      params: RequestParams = {},
    ) =>
      this.request<AccommodationRoomDto, any>({
        path: `/accommodation-rooms/${eventId}`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name AccommodationRoomsControllerFindAll
     * @request GET:/accommodation-rooms/events/{eventId}
     */
    accommodationRoomsControllerFindAll: (eventId: string, params: RequestParams = {}) =>
      this.request<AccommodationRoomsDto, any>({
        path: `/accommodation-rooms/events/${eventId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name AccommodationRoomsControllerFindOne
     * @request GET:/accommodation-rooms/{id}
     */
    accommodationRoomsControllerFindOne: (id: string, params: RequestParams = {}) =>
      this.request<AccommodationRoomDto, any>({
        path: `/accommodation-rooms/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name AccommodationRoomsControllerUpdate
     * @request PATCH:/accommodation-rooms/{id}
     */
    accommodationRoomsControllerUpdate: (id: string, data: UpdateAccommodationRoomDto, params: RequestParams = {}) =>
      this.request<AccommodationRoomDto, any>({
        path: `/accommodation-rooms/${id}`,
        method: "PATCH",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name AccommodationRoomsControllerRemove
     * @request DELETE:/accommodation-rooms/{id}
     */
    accommodationRoomsControllerRemove: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/accommodation-rooms/${id}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * No description
     *
     * @name AccommodationRoomsControllerCreatePersonnel
     * @request POST:/accommodation-rooms/{id}/members
     */
    accommodationRoomsControllerCreatePersonnel: (id: string, data: CreateRoomMembersDto, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/accommodation-rooms/${id}/members`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @name AccommodationRoomsControllerRemovePersonnel
     * @request DELETE:/accommodation-rooms/{id}/members/{memberId}
     */
    accommodationRoomsControllerRemovePersonnel: (memberId: string, id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/accommodation-rooms/${id}/members/${memberId}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * No description
     *
     * @name AccommodationRoomsControllerUpdatePersonnel
     * @request PATCH:/accommodation-rooms/{id}/members/{memberId}
     */
    accommodationRoomsControllerUpdatePersonnel: (
      memberId: string,
      id: string,
      data: UpdateRoomMemberDto,
      params: RequestParams = {},
    ) =>
      this.request<RoomMemberDto, any>({
        path: `/accommodation-rooms/${id}/members/${memberId}`,
        method: "PATCH",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  tourFiles = {
    /**
     * No description
     *
     * @name TourFilesControllerUploadFile
     * @request POST:/tour-files/{tourId}
     */
    tourFilesControllerUploadFile: (tourId: string, data: CreateTourFileDto, params: RequestParams = {}) =>
      this.request<CreatedTourFileDto, any>({
        path: `/tour-files/${tourId}`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name TourFilesControllerFindAllByTour
     * @request GET:/tour-files
     */
    tourFilesControllerFindAllByTour: (
      query?: {
        tourId?: string | null;
        artistId?: string | null;
        sortOrder?: "asc" | "desc";
        sortBy?: "createdAt" | "name";
        folderId?: uuid | null;
        isRoot?: boolean | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<TourFilesDto, any>({
        path: `/tour-files`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name TourFilesControllerDeleteFile
     * @request DELETE:/tour-files/{id}
     */
    tourFilesControllerDeleteFile: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/tour-files/${id}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * No description
     *
     * @name TourFilesControllerUpdateTourFile
     * @request PATCH:/tour-files/{id}
     */
    tourFilesControllerUpdateTourFile: (id: string, data: UpdateTourFileDto, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/tour-files/${id}`,
        method: "PATCH",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @name TourFilesControllerRearrangeTourFiles
     * @request PATCH:/tour-files/rearrange
     */
    tourFilesControllerRearrangeTourFiles: (data: ReorderTourFilesDto, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/tour-files/rearrange`,
        method: "PATCH",
        body: data,
        type: ContentType.Json,
        ...params,
      }),
  };
  files = {
    /**
     * No description
     *
     * @name FilesControllerDeleteFile
     * @request DELETE:/files/{id}
     */
    filesControllerDeleteFile: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/files/${id}`,
        method: "DELETE",
        ...params,
      }),
  };
  supplementalAnswers = {
    /**
     * No description
     *
     * @name SupplementalAnswersControllerCreate
     * @request POST:/supplemental-answers
     */
    supplementalAnswersControllerCreate: (data: CreateSupplementalAnswerDto, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/supplemental-answers`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @name SupplementalAnswersControllerUpdate
     * @request PATCH:/supplemental-answers/{id}
     */
    supplementalAnswersControllerUpdate: (id: string, data: UpdateSupplementalAnswerDto, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/supplemental-answers/${id}`,
        method: "PATCH",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @name SupplementalAnswersControllerFindOne
     * @request GET:/supplemental-answers/{id}
     */
    supplementalAnswersControllerFindOne: (id: string, params: RequestParams = {}) =>
      this.request<SupplementalAnswerDto, any>({
        path: `/supplemental-answers/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name SupplementalAnswersControllerRemove
     * @request DELETE:/supplemental-answers/{id}
     */
    supplementalAnswersControllerRemove: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/supplemental-answers/${id}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * No description
     *
     * @name SupplementalAnswersControllerFindForUser
     * @request GET:/supplemental-answers/users/{userId}
     */
    supplementalAnswersControllerFindForUser: (userId: string, params: RequestParams = {}) =>
      this.request<SupplementalAnswersDto, any>({
        path: `/supplemental-answers/users/${userId}`,
        method: "GET",
        format: "json",
        ...params,
      }),
  };
  supplementalQuestions = {
    /**
     * No description
     *
     * @name SupplementalQuestionsControllerFindAllForCountry
     * @request GET:/supplemental-questions
     */
    supplementalQuestionsControllerFindAllForCountry: (
      query?: {
        country?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<SupplementalQuestionsDto, any>({
        path: `/supplemental-questions`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name SupplementalQuestionsControllerFindAllForTour
     * @request GET:/supplemental-questions/{tourId}
     */
    supplementalQuestionsControllerFindAllForTour: (tourId: string, params: RequestParams = {}) =>
      this.request<SupplementalQuestionsDto, any>({
        path: `/supplemental-questions/${tourId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name SupplementalQuestionsControllerFindUnanswered
     * @request GET:/supplemental-questions/unanswered/{tourId}
     */
    supplementalQuestionsControllerFindUnanswered: (tourId: string, params: RequestParams = {}) =>
      this.request<SupplementalQuestionsDto, any>({
        path: `/supplemental-questions/unanswered/${tourId}`,
        method: "GET",
        format: "json",
        ...params,
      }),
  };
  dayFiles = {
    /**
     * No description
     *
     * @name DayFilesControllerCreate
     * @request POST:/day-files
     */
    dayFilesControllerCreate: (data: CreateDayFileDto, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/day-files`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @name DayFilesControllerFindAll
     * @request GET:/day-files/{tourDayId}
     */
    dayFilesControllerFindAll: (
      tourDayId: string,
      query?: {
        folderId?: uuid | null;
        isRoot?: boolean | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<DayFilesDto, any>({
        path: `/day-files/${tourDayId}`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name DayFilesControllerDelete
     * @request DELETE:/day-files/{id}
     */
    dayFilesControllerDelete: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/day-files/${id}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * No description
     *
     * @name DayFilesControllerUpdateTourFile
     * @request PATCH:/day-files/{id}
     */
    dayFilesControllerUpdateTourFile: (id: string, data: UpdateDayFileDto, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/day-files/${id}`,
        method: "PATCH",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @name DayFilesControllerRearrangeDayFiles
     * @request PATCH:/day-files/rearrange
     */
    dayFilesControllerRearrangeDayFiles: (data: ReorderDayFilesDto, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/day-files/rearrange`,
        method: "PATCH",
        body: data,
        type: ContentType.Json,
        ...params,
      }),
  };
  riderLaborTypes = {
    /**
     * No description
     *
     * @name RiderLaborTypesControllerCreate
     * @request POST:/rider-labor-types
     */
    riderLaborTypesControllerCreate: (data: CreateRiderLaborTypeDto, params: RequestParams = {}) =>
      this.request<RiderLaborTypeDto, any>({
        path: `/rider-labor-types`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name RiderLaborTypesControllerFindAll
     * @request GET:/rider-labor-types/{tourId}
     */
    riderLaborTypesControllerFindAll: (tourId: string, params: RequestParams = {}) =>
      this.request<RiderLaborTypesDto, any>({
        path: `/rider-labor-types/${tourId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name RiderLaborTypesControllerRemove
     * @request DELETE:/rider-labor-types/{id}
     */
    riderLaborTypesControllerRemove: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/rider-labor-types/${id}`,
        method: "DELETE",
        ...params,
      }),
  };
  productionTrackers = {
    /**
     * No description
     *
     * @name ProductionTrackersControllerCreate
     * @request POST:/production-trackers
     */
    productionTrackersControllerCreate: (data: CreateProductionTrackerDto, params: RequestParams = {}) =>
      this.request<ProductionTrackerDto[], any>({
        path: `/production-trackers`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name ProductionTrackersControllerFindOne
     * @request GET:/production-trackers
     */
    productionTrackersControllerFindOne: (
      query?: {
        eventId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ProductionTrackerDto, any>({
        path: `/production-trackers`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name ProductionTrackersControllerUpdate
     * @request PATCH:/production-trackers/{id}
     */
    productionTrackersControllerUpdate: (id: string, data: UpdateProductionTrackerDto, params: RequestParams = {}) =>
      this.request<ProductionTrackerDto, any>({
        path: `/production-trackers/${id}`,
        method: "PATCH",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name ProductionTrackersControllerDelete
     * @request DELETE:/production-trackers/{id}
     */
    productionTrackersControllerDelete: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/production-trackers/${id}`,
        method: "DELETE",
        ...params,
      }),
  };
  flights = {
    /**
     * No description
     *
     * @name FlightsControllerGetFlights
     * @request GET:/flights
     */
    flightsControllerGetFlights: (
      query: {
        startDate: string;
        endDate: string;
        airline: string;
        flightNumber: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<FlightsInfoDto, any>({
        path: `/flights`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),
  };
  passportExpiration = {
    /**
     * No description
     *
     * @name PassportExpirationControllerFindOne
     * @request GET:/passport-expiration/{tourId}
     */
    passportExpirationControllerFindOne: (tourId: string, params: RequestParams = {}) =>
      this.request<ExpiringPassportsDto, any>({
        path: `/passport-expiration/${tourId}`,
        method: "GET",
        format: "json",
        ...params,
      }),
  };
  googleApi = {
    /**
     * No description
     *
     * @name GoogleApiControllerSearchPlaces
     * @summary Search Places
     * @request POST:/google-api/places
     */
    googleApiControllerSearchPlaces: (data: QueryPlacesDto, params: RequestParams = {}) =>
      this.request<GooglePlacesDto, any>({
        path: `/google-api/places`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name GoogleApiControllerSearchLocationPlaces
     * @summary Search Places (Locations only)
     * @request POST:/google-api/places/locations
     */
    googleApiControllerSearchLocationPlaces: (data: QueryPlacesDto, params: RequestParams = {}) =>
      this.request<GooglePlacesLocationsDto, any>({
        path: `/google-api/places/locations`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name GoogleApiControllerGetPlaceCoordinates
     * @summary Get coordinates for a place by placeId
     * @request POST:/google-api/places/coordinates
     */
    googleApiControllerGetPlaceCoordinates: (data: QueryPlaceCoordinatesDto, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/google-api/places/coordinates`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @name GoogleApiControllerGetTimezone
     * @summary Get Timezone
     * @request GET:/google-api/timezone
     */
    googleApiControllerGetTimezone: (
      query: {
        latitude: string;
        longitude: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<GoogleTimezoneDto, any>({
        path: `/google-api/timezone`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name GoogleApiControllerGetTravelTime
     * @summary Get Estimated Travel Time
     * @request POST:/google-api/travel-time
     */
    googleApiControllerGetTravelTime: (data: QueryTravelTimeDto, params: RequestParams = {}) =>
      this.request<GoogleTravelTimeDto, any>({
        path: `/google-api/travel-time`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  roadieRecs = {
    /**
     * No description
     *
     * @name RoadieRecsControllerCreate
     * @request POST:/roadie-recs
     */
    roadieRecsControllerCreate: (data: CreateRoadieRecDto, params: RequestParams = {}) =>
      this.request<RoadieRecCreateResponseDto, any>({
        path: `/roadie-recs`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name RoadieRecsControllerFindMany
     * @request GET:/roadie-recs
     */
    roadieRecsControllerFindMany: (
      query?: {
        category?:
          | "BREAKFAST"
          | "COFFEE_SHOPS"
          | "DINNER"
          | "AFTER_SHOW"
          | "BARS"
          | "ACTIVITIES"
          | "FLUFF_AND_FOLD"
          | "SHOPPING"
          | "RECORD_SHOPS"
          | "ROCK_DOCS"
          | "VOLUNTEER"
          | "HOTELS"
          | "TATTOOS"
          | "BARBERS"
          | "HAIR"
          | "PIERCING"
          | "SPA"
          | "FITNESS"
          | "OTHER";
        /** Full name match */
        user?: string;
        near_me?: string;
        q?: string;
        city?: string;
        mine?: "created" | "upvoted" | "any";
        cursor?: string | null;
        /** @max 50 */
        limit?: number | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<RoadieRecsDto, any>({
        path: `/roadie-recs`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name RoadieRecsControllerPhotoProxy
     * @request GET:/roadie-recs/photos
     */
    roadieRecsControllerPhotoProxy: (
      query?: {
        format?: "bytes" | "uri";
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/roadie-recs/photos`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @name RoadieRecsControllerFindOne
     * @request GET:/roadie-recs/{id}
     */
    roadieRecsControllerFindOne: (id: string, params: RequestParams = {}) =>
      this.request<RoadieRecDetailDto, any>({
        path: `/roadie-recs/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name RoadieRecsControllerUpvote
     * @request POST:/roadie-recs/{id}/upvote
     */
    roadieRecsControllerUpvote: (id: string, params: RequestParams = {}) =>
      this.request<RoadieRecUpvoteResponseDto, any>({
        path: `/roadie-recs/${id}/upvote`,
        method: "POST",
        format: "json",
        ...params,
      }),
  };
  stripe = {
    /**
     * No description
     *
     * @name StripeControllerListPrices
     * @request GET:/stripe/prices
     */
    stripeControllerListPrices: (params: RequestParams = {}) =>
      this.request<PricesDto, any>({
        path: `/stripe/prices`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name StripeControllerCreateSession
     * @request POST:/stripe/checkout-session
     */
    stripeControllerCreateSession: (data: CreateCheckoutSessionDto, params: RequestParams = {}) =>
      this.request<CheckoutUrlDto, any>({
        path: `/stripe/checkout-session`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name StripeControllerHandleWebhook
     * @request POST:/stripe/webhook
     */
    stripeControllerHandleWebhook: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/stripe/webhook`,
        method: "POST",
        ...params,
      }),

    /**
     * No description
     *
     * @name StripeControllerPaymentSucceeded
     * @request POST:/stripe/webhooks/invoice-payment-succeeded
     */
    stripeControllerPaymentSucceeded: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/stripe/webhooks/invoice-payment-succeeded`,
        method: "POST",
        ...params,
      }),

    /**
     * No description
     *
     * @name StripeControllerSubscriptionUpdated
     * @request POST:/stripe/webhooks/customer-subscription-updated
     */
    stripeControllerSubscriptionUpdated: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/stripe/webhooks/customer-subscription-updated`,
        method: "POST",
        ...params,
      }),

    /**
     * No description
     *
     * @name StripeControllerSubscriptionDeleted
     * @request POST:/stripe/webhooks/customer-subscription-deleted
     */
    stripeControllerSubscriptionDeleted: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/stripe/webhooks/customer-subscription-deleted`,
        method: "POST",
        ...params,
      }),
  };
  terms = {
    /**
     * No description
     *
     * @name TermsControllerAcceptanceCheck
     * @request GET:/terms/acceptance-check
     */
    termsControllerAcceptanceCheck: (params: RequestParams = {}) =>
      this.request<TermsAcceptanceCheckDto, any>({
        path: `/terms/acceptance-check`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name TermsControllerFindAll
     * @request GET:/terms
     */
    termsControllerFindAll: (params: RequestParams = {}) =>
      this.request<TermsDto, any>({
        path: `/terms`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name TermsControllerFindOne
     * @request GET:/terms/{id}
     */
    termsControllerFindOne: (id: string, params: RequestParams = {}) =>
      this.request<TermDto, any>({
        path: `/terms/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name TermsControllerAccept
     * @request POST:/terms/{id}/accept
     */
    termsControllerAccept: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/terms/${id}/accept`,
        method: "POST",
        ...params,
      }),
  };
  privacyPolicies = {
    /**
     * No description
     *
     * @name PrivacyPoliciesControllerAcceptanceCheck
     * @request GET:/privacy-policies/acceptance-check
     */
    privacyPoliciesControllerAcceptanceCheck: (params: RequestParams = {}) =>
      this.request<PolicyAcceptanceCheckDto, any>({
        path: `/privacy-policies/acceptance-check`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name PrivacyPoliciesControllerFindAll
     * @request GET:/privacy-policies
     */
    privacyPoliciesControllerFindAll: (params: RequestParams = {}) =>
      this.request<PrivacyPoliciesDto, any>({
        path: `/privacy-policies`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name PrivacyPoliciesControllerFindOne
     * @request GET:/privacy-policies/{id}
     */
    privacyPoliciesControllerFindOne: (id: string, params: RequestParams = {}) =>
      this.request<PrivacyPolicyDto, any>({
        path: `/privacy-policies/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name PrivacyPoliciesControllerAccept
     * @request POST:/privacy-policies/{id}/accept
     */
    privacyPoliciesControllerAccept: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/privacy-policies/${id}/accept`,
        method: "POST",
        ...params,
      }),
  };
  twilio = {
    /**
     * No description
     *
     * @name TwilioControllerSendMessage
     * @request POST:/twilio/whats-app-message
     */
    twilioControllerSendMessage: (data: WhatsappMessageDto, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/twilio/whats-app-message`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),
  };
  workspaceTeams = {
    /**
     * No description
     *
     * @name WorkspaceTeamsControllerFindAll
     * @request GET:/workspace-teams
     */
    workspaceTeamsControllerFindAll: (
      query: {
        workspaceId: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<WorkspaceTeamsDto, any>({
        path: `/workspace-teams`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name WorkspaceTeamsControllerCreate
     * @request POST:/workspace-teams
     */
    workspaceTeamsControllerCreate: (data: CreateWorkspaceTeamDto, params: RequestParams = {}) =>
      this.request<WorkspaceTeamDto, any>({
        path: `/workspace-teams`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name WorkspaceTeamsControllerGetAvailabilities
     * @request GET:/workspace-teams/{id}/availabilities
     */
    workspaceTeamsControllerGetAvailabilities: (
      id: string,
      query: {
        /** @format date-time */
        from: string;
        /** @format date-time */
        to: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<UsersAvailabilitiesDto, any>({
        path: `/workspace-teams/${id}/availabilities`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name WorkspaceTeamsControllerCreateEstimate
     * @request POST:/workspace-teams/{id}/estimates
     */
    workspaceTeamsControllerCreateEstimate: (id: string, data: CreateMemoEstimateDto, params: RequestParams = {}) =>
      this.request<MemoEstimateDto, any>({
        path: `/workspace-teams/${id}/estimates`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name WorkspaceTeamsControllerGetEstimates
     * @request GET:/workspace-teams/{id}/estimates
     */
    workspaceTeamsControllerGetEstimates: (
      id: string,
      query?: {
        workspaceTeamMemberId?: string;
        tourId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<MemoEstimatesDto, any>({
        path: `/workspace-teams/${id}/estimates`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name WorkspaceTeamsControllerGetTours
     * @request GET:/workspace-teams/{id}/tours
     */
    workspaceTeamsControllerGetTours: (id: string, params: RequestParams = {}) =>
      this.request<WorkspaceTeamToursDto, any>({
        path: `/workspace-teams/${id}/tours`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name WorkspaceTeamsControllerFindOne
     * @request GET:/workspace-teams/{id}
     */
    workspaceTeamsControllerFindOne: (id: string, params: RequestParams = {}) =>
      this.request<WorkspaceTeamDto, any>({
        path: `/workspace-teams/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name WorkspaceTeamsControllerUpdate
     * @request PATCH:/workspace-teams/{id}
     */
    workspaceTeamsControllerUpdate: (id: string, data: UpdateWorkspaceTeamDto, params: RequestParams = {}) =>
      this.request<WorkspaceTeamDto, any>({
        path: `/workspace-teams/${id}`,
        method: "PATCH",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name WorkspaceTeamsControllerRemove
     * @request DELETE:/workspace-teams/{id}
     */
    workspaceTeamsControllerRemove: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/workspace-teams/${id}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * No description
     *
     * @name WorkspaceTeamsControllerCreateTeamInvitations
     * @request POST:/workspace-teams/{id}/members
     */
    workspaceTeamsControllerCreateTeamInvitations: (
      id: string,
      data: CreateWorkspaceTeamInvitationDto,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/workspace-teams/${id}/members`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @name WorkspaceTeamsControllerFindMembers
     * @request GET:/workspace-teams/{id}/members
     */
    workspaceTeamsControllerFindMembers: (id: string, params: RequestParams = {}) =>
      this.request<WorkspaceTeamMembersDto, any>({
        path: `/workspace-teams/${id}/members`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name WorkspaceTeamsControllerFindMember
     * @request GET:/workspace-teams/{id}/members/{memberId}
     */
    workspaceTeamsControllerFindMember: (id: string, memberId: string, params: RequestParams = {}) =>
      this.request<WorkspaceTeamMemberDto, any>({
        path: `/workspace-teams/${id}/members/${memberId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name WorkspaceTeamsControllerUpdateMember
     * @request PATCH:/workspace-teams/{id}/members/{memberId}
     */
    workspaceTeamsControllerUpdateMember: (
      id: string,
      memberId: string,
      data: UpdateWorkspaceTeamMemberDto,
      params: RequestParams = {},
    ) =>
      this.request<WorkspaceTeamMemberDto, any>({
        path: `/workspace-teams/${id}/members/${memberId}`,
        method: "PATCH",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name WorkspaceTeamsControllerRemoveMember
     * @request DELETE:/workspace-teams/{id}/members/{memberId}
     */
    workspaceTeamsControllerRemoveMember: (id: string, memberId: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/workspace-teams/${id}/members/${memberId}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * No description
     *
     * @name WorkspaceTeamsControllerCreateMemberWage
     * @request POST:/workspace-teams/{id}/members/{memberId}/wages
     */
    workspaceTeamsControllerCreateMemberWage: (
      id: string,
      memberId: string,
      data: CreateWageDto,
      params: RequestParams = {},
    ) =>
      this.request<WageDto, any>({
        path: `/workspace-teams/${id}/members/${memberId}/wages`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name WorkspaceTeamsControllerFindMemberWages
     * @request GET:/workspace-teams/{id}/members/{memberId}/wages
     */
    workspaceTeamsControllerFindMemberWages: (id: string, memberId: string, params: RequestParams = {}) =>
      this.request<WagesDto, any>({
        path: `/workspace-teams/${id}/members/${memberId}/wages`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name WorkspaceTeamsControllerUpdateMemberWage
     * @request PATCH:/workspace-teams/{id}/members/{memberId}/wages/{wageId}
     */
    workspaceTeamsControllerUpdateMemberWage: (
      id: string,
      wageId: string,
      memberId: string,
      data: UpdateWageDto,
      params: RequestParams = {},
    ) =>
      this.request<WageDto, any>({
        path: `/workspace-teams/${id}/members/${memberId}/wages/${wageId}`,
        method: "PATCH",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name WorkspaceTeamsControllerDeleteMemberWage
     * @request DELETE:/workspace-teams/{id}/members/{memberId}/wages/{wageId}
     */
    workspaceTeamsControllerDeleteMemberWage: (
      id: string,
      wageId: string,
      memberId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/workspace-teams/${id}/members/${memberId}/wages/${wageId}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * No description
     *
     * @name WorkspaceTeamsControllerUpdateEstimate
     * @request PUT:/workspace-teams/{id}/estimates/{estimateId}
     */
    workspaceTeamsControllerUpdateEstimate: (
      id: string,
      estimateId: string,
      data: UpdateMemoEstimateDto,
      params: RequestParams = {},
    ) =>
      this.request<MemoEstimateDto, any>({
        path: `/workspace-teams/${id}/estimates/${estimateId}`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name WorkspaceTeamsControllerDeleteEstimate
     * @request DELETE:/workspace-teams/{id}/estimates/{estimateId}
     */
    workspaceTeamsControllerDeleteEstimate: (id: string, estimateId: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/workspace-teams/${id}/estimates/${estimateId}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * No description
     *
     * @name WorkspaceTeamsControllerGetEstimate
     * @request GET:/workspace-teams/{id}/estimates/{estimateId}
     */
    workspaceTeamsControllerGetEstimate: (id: string, estimateId: string, params: RequestParams = {}) =>
      this.request<MemoEstimateDto, any>({
        path: `/workspace-teams/${id}/estimates/${estimateId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name WorkspaceTeamsControllerListReports
     * @request GET:/workspace-teams/{id}/summary-reports
     */
    workspaceTeamsControllerListReports: (id: string, params: RequestParams = {}) =>
      this.request<SummaryReportsDto, any>({
        path: `/workspace-teams/${id}/summary-reports`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name WorkspaceTeamsControllerCreateSummaryReports
     * @request POST:/workspace-teams/{id}/summary-reports
     */
    workspaceTeamsControllerCreateSummaryReports: (
      id: string,
      data: CreateMemberSummaryReportDto,
      params: RequestParams = {},
    ) =>
      this.request<SummaryReportsDto, any>({
        path: `/workspace-teams/${id}/summary-reports`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  invitations = {
    /**
     * No description
     *
     * @name InvitationsControllerFindAll
     * @request GET:/invitations
     */
    invitationsControllerFindAll: (params: RequestParams = {}) =>
      this.request<InvitationsDto, any>({
        path: `/invitations`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name InvitationsControllerAccept
     * @request POST:/invitations/workspace-team/{invitationId}/accept
     */
    invitationsControllerAccept: (invitationId: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/invitations/workspace-team/${invitationId}/accept`,
        method: "POST",
        ...params,
      }),

    /**
     * No description
     *
     * @name InvitationsControllerDecline
     * @request DELETE:/invitations/workspace-team/{invitationId}/decline
     */
    invitationsControllerDecline: (invitationId: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/invitations/workspace-team/${invitationId}/decline`,
        method: "DELETE",
        ...params,
      }),

    /**
     * No description
     *
     * @name InvitationsControllerAcceptTourInvitation
     * @request POST:/invitations/tour/{invitationId}/accept
     */
    invitationsControllerAcceptTourInvitation: (invitationId: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/invitations/tour/${invitationId}/accept`,
        method: "POST",
        ...params,
      }),

    /**
     * No description
     *
     * @name InvitationsControllerDeclineTourInvitation
     * @request DELETE:/invitations/tour/{invitationId}/decline
     */
    invitationsControllerDeclineTourInvitation: (invitationId: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/invitations/tour/${invitationId}/decline`,
        method: "DELETE",
        ...params,
      }),
  };
  combinedCalendar = {
    /**
     * No description
     *
     * @name CombinedCalendarControllerFindAllByTour
     * @request GET:/combined-calendar
     */
    combinedCalendarControllerFindAllByTour: (
      query?: {
        /** @format date-time */
        from?: string;
        /** @format date-time */
        to?: string;
        workspaceId?: string | null;
        /** Array of UUIDs */
        tourIds?: any[] | null;
        /** Array of UUIDs */
        artistIds?: any[] | null;
        /** Array of UUIDs */
        groupIds?: any[] | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<CombinedCalendarEventsDto, any>({
        path: `/combined-calendar`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),
  };
  venueFormSubmissions = {
    /**
     * No description
     *
     * @name VenueFormSubmissionsControllerSubmit
     * @request PATCH:/venue-form-submissions/{id}
     */
    venueFormSubmissionsControllerSubmit: (
      id: string,
      data: UpdateVenueFormSubmissionDto,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/venue-form-submissions/${id}`,
        method: "PATCH",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @name VenueFormSubmissionsControllerFindOne
     * @request GET:/venue-form-submissions/{id}
     */
    venueFormSubmissionsControllerFindOne: (id: string, params: RequestParams = {}) =>
      this.request<VenueFormSubmissionDto, any>({
        path: `/venue-form-submissions/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name VenueFormSubmissionsControllerUploadFile
     * @request POST:/venue-form-submissions/{id}/files
     */
    venueFormSubmissionsControllerUploadFile: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/venue-form-submissions/${id}/files`,
        method: "POST",
        ...params,
      }),

    /**
     * No description
     *
     * @name VenueFormSubmissionsControllerRemove
     * @request DELETE:/venue-form-submissions/{id}/files/{submissionFileId}
     */
    venueFormSubmissionsControllerRemove: (submissionFileId: string, id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/venue-form-submissions/${id}/files/${submissionFileId}`,
        method: "DELETE",
        ...params,
      }),
  };
  travelTracker = {
    /**
     * No description
     *
     * @name TravelTrackerControllerGetTravelTracker
     * @request GET:/travel-tracker/{tourId}
     */
    travelTrackerControllerGetTravelTracker: (
      tourId: string,
      query: {
        /** Start date in YYYY-MM-DD format */
        from: string;
        /** End date in YYYY-MM-DD format */
        to: string;
        /** Array of UUIDs */
        groupIds?: any[] | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<TravelTrackerResponseDto, any>({
        path: `/travel-tracker/${tourId}`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),
  };
  tourFolders = {
    /**
     * No description
     *
     * @tags Tour Folders
     * @name TourFoldersControllerCreate
     * @summary Create tour folder
     * @request POST:/tour-folders
     * @secure
     */
    tourFoldersControllerCreate: (data: CreateTourFolderDto, params: RequestParams = {}) =>
      this.request<TourFolderDto, any>({
        path: `/tour-folders`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Tour Folders
     * @name TourFoldersControllerUpdate
     * @summary Update tour folder
     * @request PATCH:/tour-folders/{id}
     * @secure
     */
    tourFoldersControllerUpdate: (id: string, data: UpdateTourFolderDto, params: RequestParams = {}) =>
      this.request<TourFolderDto, any>({
        path: `/tour-folders/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Tour Folders
     * @name TourFoldersControllerRemove
     * @summary Delete tour folder
     * @request DELETE:/tour-folders/{id}
     * @secure
     */
    tourFoldersControllerRemove: (id: string, params: RequestParams = {}) =>
      this.request<TourFolderDto, any>({
        path: `/tour-folders/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  personalNotes = {
    /**
     * No description
     *
     * @name PersonalNotesControllerCreate
     * @request POST:/personal-notes
     */
    personalNotesControllerCreate: (data: CreatePersonalNoteDto, params: RequestParams = {}) =>
      this.request<PersonalNoteDto, any>({
        path: `/personal-notes`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name PersonalNotesControllerFindAll
     * @request GET:/personal-notes
     */
    personalNotesControllerFindAll: (
      query?: {
        title?: string;
        sortBy?: "title" | "due_date" | "created_at" | "status" | "priority";
        sortOrder?: "asc" | "desc";
        /** Include archived notes in results */
        includeArchived?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<PersonalNotesDto, any>({
        path: `/personal-notes`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name PersonalNotesControllerFindOverdue
     * @request GET:/personal-notes/overdue
     */
    personalNotesControllerFindOverdue: (params: RequestParams = {}) =>
      this.request<PersonalNotesDto, any>({
        path: `/personal-notes/overdue`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name PersonalNotesControllerFindOne
     * @request GET:/personal-notes/{id}
     */
    personalNotesControllerFindOne: (id: string, params: RequestParams = {}) =>
      this.request<PersonalNoteDto, any>({
        path: `/personal-notes/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name PersonalNotesControllerUpdate
     * @request PATCH:/personal-notes/{id}
     */
    personalNotesControllerUpdate: (id: string, data: UpdatePersonalNoteDto, params: RequestParams = {}) =>
      this.request<PersonalNoteDto, any>({
        path: `/personal-notes/${id}`,
        method: "PATCH",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name PersonalNotesControllerRemove
     * @request DELETE:/personal-notes/{id}
     */
    personalNotesControllerRemove: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/personal-notes/${id}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * No description
     *
     * @name PersonalNotesControllerArchive
     * @request PATCH:/personal-notes/{id}/archive
     */
    personalNotesControllerArchive: (id: string, params: RequestParams = {}) =>
      this.request<PersonalNoteDto, any>({
        path: `/personal-notes/${id}/archive`,
        method: "PATCH",
        format: "json",
        ...params,
      }),
  };
  userScratchpads = {
    /**
     * No description
     *
     * @tags user-scratchpads
     * @name UserScratchpadsControllerCreate
     * @request POST:/user-scratchpads
     */
    userScratchpadsControllerCreate: (data: CreateScratchpadDto, params: RequestParams = {}) =>
      this.request<ScratchpadDto, any>({
        path: `/user-scratchpads`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags user-scratchpads
     * @name UserScratchpadsControllerFindAll
     * @request GET:/user-scratchpads
     */
    userScratchpadsControllerFindAll: (params: RequestParams = {}) =>
      this.request<ScratchpadsDto, any>({
        path: `/user-scratchpads`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags user-scratchpads
     * @name UserScratchpadsControllerFindOne
     * @request GET:/user-scratchpads/{id}
     */
    userScratchpadsControllerFindOne: (id: string, params: RequestParams = {}) =>
      this.request<ScratchpadDto, any>({
        path: `/user-scratchpads/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags user-scratchpads
     * @name UserScratchpadsControllerUpdate
     * @request PATCH:/user-scratchpads/{id}
     */
    userScratchpadsControllerUpdate: (id: string, data: UpdateScratchpadDto, params: RequestParams = {}) =>
      this.request<ScratchpadDto, any>({
        path: `/user-scratchpads/${id}`,
        method: "PATCH",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags user-scratchpads
     * @name UserScratchpadsControllerRemove
     * @request DELETE:/user-scratchpads/{id}
     */
    userScratchpadsControllerRemove: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/user-scratchpads/${id}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * No description
     *
     * @tags user-scratchpads
     * @name UserScratchpadsControllerUploadAsset
     * @request POST:/user-scratchpads/assets
     */
    userScratchpadsControllerUploadAsset: (data: UploadScratchpadAssetDto, params: RequestParams = {}) =>
      this.request<ScratchpadAssetDto, any>({
        path: `/user-scratchpads/assets`,
        method: "POST",
        body: data,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags user-scratchpads
     * @name UserScratchpadsControllerDeleteAsset
     * @request DELETE:/user-scratchpads/assets/{assetId}
     */
    userScratchpadsControllerDeleteAsset: (assetId: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/user-scratchpads/assets/${assetId}`,
        method: "DELETE",
        ...params,
      }),
  };
  directory = {
    /**
     * No description
     *
     * @name DirectoryControllerList
     * @request GET:/directory
     */
    directoryControllerList: (
      query?: {
        /** @deprecated */
        filter?: "all" | "active_tour" | "previous_tours";
        q?: string | null;
        cursor?: string | null;
        /** @max 50 */
        limit?: number | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<DirectoryListDto, any>({
        path: `/directory`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name DirectoryControllerListTourRelated
     * @request GET:/directory/tour-related
     */
    directoryControllerListTourRelated: (
      query?: {
        q?: string | null;
        /** Only return people whose email is visible to the viewer (viewer holds an admin role on a shared tour). Used by the invite typeahead so pagination is not consumed by rows with a hidden email. */
        requireEmail?: boolean;
        /**
         * Exclude people who are already tour personnel on this tour or have a pending invitation to it, before pagination. Requires the viewer to hold an admin role on the tour (403 otherwise). Used by the invite typeahead so already-added people do not consume the page.
         * @format uuid
         */
        excludeTourId?: string;
        /** Whether to also match About Me text. Defaults to true; the invite typeaheads (web assign-personnel and mobile add-crew) send false so they do not suggest people solely because their About Me matches. */
        searchAboutMe?: boolean;
        /**
         * @min 0
         * @default 0
         */
        offset?: number | null;
        /**
         * @min 1
         * @max 50
         * @default 10
         */
        limit?: number | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<DirectoryTourRelatedListDto, any>({
        path: `/directory/tour-related`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name DirectoryControllerProfile
     * @request GET:/directory/{userId}
     */
    directoryControllerProfile: (userId: string, params: RequestParams = {}) =>
      this.request<DirectoryProfileDto, any>({
        path: `/directory/${userId}`,
        method: "GET",
        format: "json",
        ...params,
      }),
  };
  ai = {
    /**
     * No description
     *
     * @name AiControllerExtractFlightWithGeminiPdf
     * @summary Extract flight information from PDF using Gemini AI
     * @request POST:/ai/extract-flight-gemini-pdf
     */
    aiControllerExtractFlightWithGeminiPdf: (params: RequestParams = {}) =>
      this.request<FlightExtractionResponseDto, any>({
        path: `/ai/extract-flight-gemini-pdf`,
        method: "POST",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name AiControllerImportTourSchedule
     * @summary Extract, resolve, and import tour schedule using Gemini AI
     * @request POST:/ai/import-tour-schedule/{tourId}
     */
    aiControllerImportTourSchedule: (tourId: string, params: RequestParams = {}) =>
      this.request<TourScheduleImportResponseDto, any>({
        path: `/ai/import-tour-schedule/${tourId}`,
        method: "POST",
        format: "json",
        ...params,
      }),
  };
  resources = {
    /**
     * No description
     *
     * @tags Resources
     * @name ResourcesControllerFindAll
     * @request GET:/resources
     */
    resourcesControllerFindAll: (params: RequestParams = {}) =>
      this.request<ResourcesListDto, any>({
        path: `/resources`,
        method: "GET",
        format: "json",
        ...params,
      }),
  };
  communities = {
    /**
     * No description
     *
     * @tags Communities
     * @name CommunitiesControllerFindAll
     * @request GET:/communities
     */
    communitiesControllerFindAll: (params: RequestParams = {}) =>
      this.request<CommunitiesListDto, any>({
        path: `/communities`,
        method: "GET",
        format: "json",
        ...params,
      }),
  };
}
